import { Grid as Grid$1, TableFixedColumns as TableFixedColumns$1, TableGroupRow as TableGroupRow$1, TableColumnReordering as TableColumnReordering$1, TableColumnResizing as TableColumnResizing$1, TableColumnVisibility as TableColumnVisibility$1, TableHeaderRow as TableHeaderRow$1, TableSummaryRow as TableSummaryRow$1, VirtualTable as VirtualTable$1, GroupingPanel as GroupingPanel$1 } from '@devexpress/dx-react-grid-bootstrap3';
import React__default, { createElement, useMemo, useState, useCallback, useEffect, Fragment, Children, isValidElement, cloneElement, PureComponent, memo } from 'react';
import styled from 'styled-components';
import memoize from 'memoize-one';
import { DataTypeProvider, IntegratedFiltering as IntegratedFiltering$1, FilteringState as FilteringState$1, IntegratedGrouping as IntegratedGrouping$1, GroupingState as GroupingState$1, SearchState as SearchState$1, SelectionState as SelectionState$1, IntegratedSorting as IntegratedSorting$1, SortingState as SortingState$1, IntegratedSummary as IntegratedSummary$1, SummaryState as SummaryState$1 } from '@devexpress/dx-react-grid';
import { Checkbox, Icon, Button, Modal, Dropdown, MenuItem as MenuItem$1 } from 'hcss-components';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import { DropdownList, DateTimePicker } from 'react-widgets';
import createContainer from 'constate';
import { keyBy, uniqBy, sortBy, debounce, find, values, groupBy, capitalize } from 'lodash-es';
import { useLocalStorage, useSessionStorage } from 'hcss-hooks';
import momentLocalizer from 'react-widgets-moment';
import { useLocation, Link } from 'react-router-dom';
import { ContextMenu, MenuItem, SubMenu, connectMenu, ContextMenuTrigger } from 'react-contextmenu';
import numeral from 'numeral';
import { Plugin, Getter, Action, Template, TemplateConnector, TemplatePlaceholder } from '@devexpress/dx-react-core';
import { isGroupTableRow } from '@devexpress/dx-grid-core';
import { produce } from 'immer';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import { Flex, Box } from 'hcss-core';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var DataColumnType;

(function (DataColumnType) {
  DataColumnType[DataColumnType["ShortText"] = 0] = "ShortText";
  DataColumnType[DataColumnType["LongText"] = 1] = "LongText";
  DataColumnType[DataColumnType["Date"] = 2] = "Date";
  DataColumnType[DataColumnType["List"] = 3] = "List";
  DataColumnType[DataColumnType["States"] = 4] = "States";
  DataColumnType[DataColumnType["Custom"] = 5] = "Custom";
  DataColumnType[DataColumnType["Boolean"] = 6] = "Boolean";
  DataColumnType[DataColumnType["Number"] = 7] = "Number";
  DataColumnType[DataColumnType["Currency"] = 8] = "Currency";
  DataColumnType[DataColumnType["DateTime"] = 9] = "DateTime";
  DataColumnType[DataColumnType["Estimates"] = 10] = "Estimates";
  DataColumnType[DataColumnType["BidResults"] = 11] = "BidResults";
  DataColumnType[DataColumnType["Links"] = 12] = "Links";
  DataColumnType[DataColumnType["PhoneNumber"] = 13] = "PhoneNumber";
  DataColumnType[DataColumnType["CheckList"] = 14] = "CheckList"; // remove
})(DataColumnType || (DataColumnType = {}));

var SummaryType;

(function (SummaryType) {
  SummaryType["Sum"] = "sumDefaultZero";
  SummaryType["Avg"] = "avgNoNulls";
  SummaryType["Count"] = "count";
})(SummaryType || (SummaryType = {}));

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  td,\n  th {\n    background-color: #fff !important;\n  }\n  th {\n    border-right: none !important;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
function filterColumns(columns) {
  var filteredColumns = {
    numberColumns: [],
    textColumns: [],
    dateColumns: [],
    booleanColumns: []
  };
  columns.forEach(function (column) {
    if (column.type === DataColumnType.ShortText || column.type === DataColumnType.LongText) {
      filteredColumns.textColumns.push(column);
    }

    if (column.type === DataColumnType.Boolean) {
      filteredColumns.booleanColumns.push(column);
    }

    if (column.type === DataColumnType.Date || column.type === DataColumnType.DateTime) {
      filteredColumns.dateColumns.push(column);
    }

    if (column.type === DataColumnType.Number || column.type === DataColumnType.Currency) {
      filteredColumns.numberColumns.push(column);
    }
  });
  return filteredColumns;
}
var getRowId = function getRowId(row) {
  return row.id;
};
var Root = function Root(props) {
  return createElement(Grid$1.Root, Object.assign({
    style: {
      height: "100%",
      width: "100%"
    }
  }, props));
};
var TableWrapper =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject(), function (props) {
  return props.height || "calc(100vh - 250px)";
});

var generateTableColumnExtension = function generateTableColumnExtension(column, _ref) {
  var align = _ref.align,
      width = _ref.width,
      wordWrapEnabled = _ref.wordWrapEnabled;
  var columnExtension = {
    columnName: column.name,
    align: align,
    wordWrapEnabled: wordWrapEnabled
  };

  if (width) {
    columnExtension.width = width;
  }

  return columnExtension;
};
var generateTableColumnExtensions =
/*#__PURE__*/
memoize(function (columns) {
  var filteredColumns = filterColumns(columns);
  var numberColumns = filteredColumns.numberColumns.map(function (column) {
    return generateTableColumnExtension(column, {
      align: "right"
    });
  });
  var booleanColumns = filteredColumns.booleanColumns.map(function (column) {
    return generateTableColumnExtension(column, {
      align: "center",
      width: 140
    });
  });
  return [].concat(numberColumns, booleanColumns);
});

var TableFixedColumns = function TableFixedColumns(_ref) {
  var _ref$leftColumns = _ref.leftColumns,
      leftColumns = _ref$leftColumns === void 0 ? [] : _ref$leftColumns,
      props = _objectWithoutPropertiesLoose(_ref, ["leftColumns"]);

  return useMemo(function () {
    var columnsWithGroup = [TableGroupRow$1.COLUMN_TYPE].concat(leftColumns);
    return createElement(TableFixedColumns$1, Object.assign({
      leftColumns: columnsWithGroup,
      cellComponent: CellComponent
    }, props));
  }, [leftColumns, props]);
};
var CellComponent = function CellComponent(_ref2) {
  var props = _objectWithoutPropertiesLoose(_ref2, ["style"]);

  var isGroupRow = props.tableRow.type === TableGroupRow$1.ROW_TYPE;
  return createElement(TableFixedColumns$1.Cell, Object.assign({}, props, {
    showRightDivider: isGroupRow ? false : props.showRightDivider,
    style: {
      backgroundColor: isGroupRow ? "inherit" : "#FFF"
    }
  }));
};

function useColoring(templateName) {
  var _useLocalStorage = useLocalStorage(templateName + ".coloring", ""),
      coloringColumnName = _useLocalStorage[0],
      setColoringColumnName = _useLocalStorage[1];

  return {
    coloringColumnName: coloringColumnName,
    setColoringColumnName: setColoringColumnName
  };
}

function useColumnOrdering(templateName) {
  var _useLocalStorage = useLocalStorage(templateName + ".columnOrder", []),
      columnOrder = _useLocalStorage[0],
      setColumnOrder = _useLocalStorage[1];

  return {
    columnOrder: columnOrder,
    setColumnOrder: setColumnOrder
  };
}
function createDefaultColumnOrder(columns, currentOrder) {
  var newOrder = [].concat(currentOrder);
  var allColumns = columns.map(function (column) {
    return column.name;
  });
  allColumns.forEach(function (column) {
    if (newOrder.indexOf(column) === -1) {
      newOrder.push(column);
    }
  });
  return newOrder;
}

function createDefaultColumnSizes(columns, currentWidths) {
  var currentWidthHash = keyBy(currentWidths, "columnName");
  var newWidths = [].concat(currentWidths);
  columns.forEach(function (column) {
    if (!(column.name in currentWidthHash)) {
      newWidths.push({
        columnName: column.name,
        width: defaultColumnWidths({
          name: column.name,
          type: column.type
        })
      });
    }
  });
  return newWidths;
}
function useColumnResizing(templateName, columns, options) {
  var _options$defaultSizin;

  if (options === void 0) {
    options = {
      defaultSizing: []
    };
  }

  var _useLocalStorage = useLocalStorage(templateName + ".columnSizing", (_options$defaultSizin = options.defaultSizing) !== null && _options$defaultSizin !== void 0 ? _options$defaultSizin : []),
      cachedColumnWidths = _useLocalStorage[0],
      setColumnWidths = _useLocalStorage[1];

  var columnWidths = useMemo(function () {
    return createDefaultColumnSizes(columns, cachedColumnWidths);
  }, [columns, cachedColumnWidths]);
  return {
    columnWidths: columnWidths,
    setColumnWidths: setColumnWidths
  };
}
var defaultColumnWidths = function defaultColumnWidths(_ref) {
  var type = _ref.type;

  if (type === DataColumnType.Date || type === DataColumnType.DateTime) {
    return 145;
  }

  if (type === DataColumnType.LongText) {
    return 360;
  }

  if (type === DataColumnType.States) {
    return 85;
  }

  return 200;
};

function useColumnVisibility(templateName, options) {
  if (options === void 0) {
    options = {
      defaultHiddenColumns: []
    };
  }

  var _useLocalStorage = useLocalStorage(templateName + ".columnVisibility", options.defaultHiddenColumns || []),
      hiddenColumns = _useLocalStorage[0],
      setHiddenColumns = _useLocalStorage[1];

  return {
    hiddenColumns: hiddenColumns,
    setHiddenColumns: setHiddenColumns
  };
}

function useFiltering() {
  var _React$useState = useState([]),
      filters = _React$useState[0],
      setFilters = _React$useState[1];

  return {
    filters: filters,
    setFilters: setFilters
  };
}

function useGrouping(templateName, options) {
  if (options === void 0) {
    options = {
      defaultGrouping: [],
      defaultExpandedGroups: []
    };
  }

  var _useLocalStorage = useLocalStorage(templateName + ".grouping", options.defaultGrouping || []),
      grouping = _useLocalStorage[0],
      _setGrouping = _useLocalStorage[1];

  var setGrouping = useCallback(function (newGrouping) {
    var mappedColumns = newGrouping.map(function (group) {
      if (group.isVirtual) {
        return {
          columnName: group.originalColumnName,
          config: group.config
        };
      } // hack fix for working with DevExpress grid drag and drop group ordering


      var standardName = group.columnName.split("|");

      if ((standardName === null || standardName === void 0 ? void 0 : standardName[1]) === "VIRTUAL") {
        return {
          columnName: standardName[0],
          config: {
            dateGrouping: standardName[2]
          }
        };
      }

      return group;
    });
    var uniqueGroups = uniqBy(mappedColumns, function (group) {
      var _group$config;

      return group.columnName + "|" + (((_group$config = group.config) === null || _group$config === void 0 ? void 0 : _group$config.dateGrouping) || "year");
    });

    _setGrouping(uniqueGroups);
  }, [_setGrouping]);

  var _useLocalStorage2 = useLocalStorage(templateName + ".grouping.expanded", options.defaultExpandedGroups || []),
      expandedGroups = _useLocalStorage2[0],
      setExpandedGroups = _useLocalStorage2[1];

  return {
    grouping: grouping,
    setGrouping: setGrouping,
    expandedGroups: expandedGroups,
    setExpandedGroups: setExpandedGroups
  };
}

function usePagination(templateName) {
  var _React$useState = useState(0),
      currentPage = _React$useState[0],
      setCurrentPage = _React$useState[1];

  var _useLocalStorage = useLocalStorage(templateName + ".pageSize", 15),
      pageSize = _useLocalStorage[0],
      setPageSize = _useLocalStorage[1];

  return {
    currentPage: currentPage,
    setCurrentPage: setCurrentPage,
    pageSize: pageSize,
    setPageSize: setPageSize
  };
}

function useSearch(templateName) {
  var _useSessionStorage = useSessionStorage(templateName + ".searchValue", ""),
      searchValue = _useSessionStorage[0],
      setSearchValue = _useSessionStorage[1];

  return {
    searchValue: searchValue,
    setSearchValue: setSearchValue
  };
}

function useSelection() {
  var _React$useState = useState([]),
      selection = _React$useState[0],
      setSelection = _React$useState[1];

  return {
    selection: selection,
    setSelection: setSelection
  };
}

function useSorting(templateName, options) {
  if (options === void 0) {
    options = {
      defaultSorting: []
    };
  }

  var _useLocalStorage = useLocalStorage(templateName + ".sorting", options.defaultSorting || []),
      sorting = _useLocalStorage[0],
      setSorting = _useLocalStorage[1]; // const setNewSorting = (newSorting: Sorting[]) => {
  //   setSorting(newSorting);
  //   if (sorting.length || newSorting.length) {
  //     if (sorting.length && newSorting.length) {
  //       if (
  //         sorting[0].columnName !== newSorting[0].columnName ||
  //         sorting[0].direction !== newSorting[0].direction
  //       ) {
  //         setCurrentPage(0);
  //       }
  //     } else {
  //       setCurrentPage(0);
  //     }
  //   }
  // };


  return {
    sorting: sorting,
    setSorting: setSorting
  };
}
function createGroupedSorting(grouping, sorting) {
  if (grouping === void 0) {
    grouping = [];
  }

  if (sorting === void 0) {
    sorting = [];
  }

  var newSorting = [];

  for (var index = 0; index < grouping.length; index++) {
    var sortedColumn = sorting.length > index ? sorting[index] : undefined;
    var groupedColumn = grouping.length > index ? grouping[index] : undefined;

    if (groupedColumn && sortedColumn && sortedColumn.columnName === groupedColumn.columnName) {
      newSorting.push(sortedColumn);
    }

    if (groupedColumn && (!sortedColumn || sortedColumn.columnName !== groupedColumn.columnName)) {
      newSorting.push({
        columnName: groupedColumn.columnName,
        direction: "asc"
      });
    }
  }

  if (sorting.length) {
    var lastSortedColumn = sorting[sorting.length - 1];

    if (newSorting.map(function (sort) {
      return sort.columnName;
    }).indexOf(lastSortedColumn.columnName) === -1) {
      newSorting.push(lastSortedColumn);
    }
  }

  return newSorting;
}

function useSummary(templateName, options) {
  var _options$defaultSumma;

  if (options === void 0) {
    options = {
      defaultSummary: []
    };
  }

  var _useLocalStorage = useLocalStorage(templateName + ".summaryItems", (_options$defaultSumma = options.defaultSummary) !== null && _options$defaultSumma !== void 0 ? _options$defaultSumma : []),
      summaryItems = _useLocalStorage[0],
      _setSummaryItems = _useLocalStorage[1];

  var setSummaryItems = useCallback(function (val, column) {
    _setSummaryItems(function (prevSummary) {
      var newSummary = prevSummary.filter(function (c) {
        return c.columnName !== column.name;
      });
      newSummary.push({
        columnName: column.name,
        type: val
      });
      return newSummary;
    });
  }, [_setSummaryItems]);

  var showOptionToggle = function showOptionToggle(column) {
    return column.type === DataColumnType.Currency || column.type === DataColumnType.Number;
  };

  return {
    summaryItems: summaryItems,
    setSummaryItems: setSummaryItems,
    showOptionToggle: showOptionToggle
  };
}

function useVirtualColumns(columns, grouping) {
  var columnLookup = useMemo(function () {
    return keyBy(columns, "name");
  }, [columns]);
  var extendedGroups = useMemo(function () {
    return grouping.filter(function (g) {
      return g.columnName in columnLookup;
    }).map(function (group) {
      var _ref, _group$config, _columnLookup$group$c, _columnLookup$group$c2;

      var interval = (_ref = (_group$config = group.config) === null || _group$config === void 0 ? void 0 : _group$config.dateGrouping) !== null && _ref !== void 0 ? _ref : "year";
      if (((_columnLookup$group$c = columnLookup[group.columnName]) === null || _columnLookup$group$c === void 0 ? void 0 : _columnLookup$group$c.type) === DataColumnType.DateTime || ((_columnLookup$group$c2 = columnLookup[group.columnName]) === null || _columnLookup$group$c2 === void 0 ? void 0 : _columnLookup$group$c2.type) === DataColumnType.Date) return {
        columnName: group.columnName + "|VIRTUAL|" + interval,
        originalColumnName: group.columnName,
        isVirtual: true,
        config: _extends({}, group.config, {
          dateGrouping: interval
        })
      };
      return _extends({}, group, {
        isVirtual: false
      });
    });
  }, [grouping, columnLookup]);
  var virtualColumns = useMemo(function () {
    return extendedGroups.filter(function (group) {
      return group.isVirtual;
    }).map(function (group) {
      var originalColumn = columnLookup[group.originalColumnName];
      return _extends({}, originalColumn, {
        type: DataColumnType.DateTime,
        name: group.columnName,
        id: group.columnName,
        config: group.config,
        getCellValue: function getCellValue(row) {
          var _ref2, _originalColumn$getCe;

          var value = (_ref2 = (_originalColumn$getCe = originalColumn.getCellValue) === null || _originalColumn$getCe === void 0 ? void 0 : _originalColumn$getCe.call(originalColumn, row, originalColumn.name)) !== null && _ref2 !== void 0 ? _ref2 : row[originalColumn.name];

          if (value) {
            var dateValue = moment(value);

            if (dateValue.isValid()) {
              var _group$config2;

              return moment(value).startOf((_group$config2 = group.config) === null || _group$config2 === void 0 ? void 0 : _group$config2.dateGrouping);
            }
          }

          return null;
        }
      });
    });
  }, [columnLookup, extendedGroups]);
  return {
    extendedGroups: extendedGroups,
    virtualColumns: virtualColumns
  };
}

function useTable(_ref) {
  var passedColumns = _ref.columns,
      _ref$sections = _ref.sections,
      sections = _ref$sections === void 0 ? [] : _ref$sections,
      templateName = _ref.templateName,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
      _ref$defaults = _ref.defaults,
      defaults = _ref$defaults === void 0 ? {} : _ref$defaults,
      passthrough = _ref.passthrough;
  var columns = useMemo(function () {
    return normalizeColumns(passedColumns);
  }, [passedColumns]);
  var grouping = combineOverrides(useGrouping(templateName, defaults.grouping), overrides.grouping);
  var visibility = combineOverrides(useColumnVisibility(templateName, defaults.visibility), overrides.visibility);
  var summary = combineOverrides(useSummary(templateName, defaults.summary), overrides.summary);
  var order = combineOverrides(useColumnOrdering(templateName), overrides.order);
  var sorting = combineOverrides(useSorting(templateName, defaults.sorting), overrides.sorting);
  var paging = combineOverrides(usePagination(templateName), overrides.paging);
  var coloring = combineOverrides(useColoring(templateName), overrides.coloring);
  var search = combineOverrides(useSearch(templateName), overrides.search);
  var selection = combineOverrides(useSelection(), overrides.selection);
  var filtering = combineOverrides(useFiltering(), overrides.filtering);

  var _React$useState = useState(false),
      showModal = _React$useState[0],
      setShowModal = _React$useState[1];

  var _React$useState2 = useState(false),
      showProjectsModal = _React$useState2[0],
      setShowProjectsModal = _React$useState2[1];

  var _useVirtualColumns = useVirtualColumns(columns, grouping.grouping),
      virtualColumns = _useVirtualColumns.virtualColumns,
      extendedGroups = _useVirtualColumns.extendedGroups;

  var allColumns = useMemo(function () {
    return [].concat(columns, virtualColumns);
  }, [columns, virtualColumns]);
  var sizing = combineOverrides(useColumnResizing(templateName, allColumns, defaults.sizing), overrides.sizing);
  var columnLookup = useMemo(function () {
    return keyBy(allColumns, "name");
  }, [allColumns]);
  return {
    templateName: templateName,
    columns: allColumns,
    virtualColumns: virtualColumns,
    columnLookup: columnLookup,
    grouping: grouping,
    extendedGroups: extendedGroups,
    sorting: sorting,
    summary: summary,
    paging: paging,
    sizing: sizing,
    order: order,
    visibility: visibility,
    search: search,
    selection: selection,
    filtering: filtering,
    sections: sections,
    coloring: coloring,
    columnSelect: {
      showModal: showModal,
      setShowModal: setShowModal
    },
    highlightProjects: {
      showProjectsModal: showProjectsModal,
      setShowProjectsModal: setShowProjectsModal
    },
    passthrough: passthrough
  };
}

function normalizeColumns(columns) {
  return columns.map(function (col) {
    var _col$groupingEnabled, _col$hidingEnabled;

    return _extends({}, col, {
      groupingEnabled: (_col$groupingEnabled = col.groupingEnabled) !== null && _col$groupingEnabled !== void 0 ? _col$groupingEnabled : true,
      hidingEnabled: (_col$hidingEnabled = col.hidingEnabled) !== null && _col$hidingEnabled !== void 0 ? _col$hidingEnabled : true
    });
  });
}

function combineOverrides(original, override) {
  if (override === void 0) {
    override = {};
  }

  return _extends({}, original, {}, override);
}

var useTableContext =
/*#__PURE__*/
createContainer(function (props) {
  return useTable(props);
});

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  & .rw-widget-input {\n    height: 34px;\n    ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-right: 8px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  & .rw-widget-picker {\n    height: 34px;\n  }\n  & .rw-cell.rw-state-selected {\n    color: black !important;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  & input {\n    display: block;\n    width: 100%;\n    height: 34px;\n    padding: 6px 12px;\n    font-size: 14px;\n    line-height: 1.42857143;\n    color: #555;\n    background-color: ", ";\n    cursor: ", ";\n    background-image: none;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n    -webkit-transition: border-color ease-in-out 0.15s,\n      -webkit-box-shadow ease-in-out 0.15s;\n    -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  }\n\n  & input:focus {\n    border-color: ", ";\n    outline: 0;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),\n      0 0 8px rgba(102, 175, 233, 0.6);\n    box-shadow: ", ";\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var localizer =
/*#__PURE__*/
momentLocalizer();
var TextEditor = function TextEditor(props) {
  var _column$config2;

  var column = props.column;
  var onValueChange = props.onValueChange,
      initialValue = props.value;

  var _useDebouncedGridValu = useDebouncedGridValue(initialValue, onValueChange),
      value = _useDebouncedGridValu[0],
      setValue = _useDebouncedGridValu[1];

  var isDisabled = column.readOnly || props.disabled;
  return React__default.createElement("input", {
    value: value,
    onChange: function onChange(e) {
      var _ref, _column$config, _column$config$setCel;

      return setValue((_ref = (_column$config = column.config) === null || _column$config === void 0 ? void 0 : (_column$config$setCel = _column$config.setCellValue) === null || _column$config$setCel === void 0 ? void 0 : _column$config$setCel.call(_column$config, e.target.value)) !== null && _ref !== void 0 ? _ref : e.target.value);
    },
    type: "text",
    disabled: isDisabled,
    className: "form-control",
    maxLength: (_column$config2 = column.config) === null || _column$config2 === void 0 ? void 0 : _column$config2.maxLength
  });
};
var TextProvider = function TextProvider() {
  var _useTableContext = useTableContext(),
      columns = _useTableContext.columns;

  return React__default.useMemo(function () {
    return React__default.createElement(DataTypeProvider, {
      editorComponent: TextEditor,
      "for": columns.filter(function (column) {
        return column.type === DataColumnType.ShortText || column.type === DataColumnType.LongText;
      }).map(function (column) {
        return column.name;
      })
    });
  }, [columns]);
};
var NumberFormatter = function NumberFormatter(props) {
  var value = props.value;
  var column = props.column;

  if (value !== undefined && value !== null && typeof value === "number") {
    return React__default.createElement("span", {
      style: {
        "float": "right"
      }
    }, React__default.createElement(NumberFormat, {
      displayType: "text",
      thousandSeparator: true,
      decimalScale: column.type === DataColumnType.Currency ? 2 : 5,
      value: value,
      prefix: column.type === DataColumnType.Currency ? "$" : undefined,
      fixedDecimalScale: column.type === DataColumnType.Currency ? true : false
    }));
  }

  return null;
};
var NumberEditor = function NumberEditor(props) {
  var _ref2, _column$config3;

  var initialValue = props.value,
      onValueChange = props.onValueChange;

  var _useDebouncedGridValu2 = useDebouncedGridValue(initialValue, onValueChange),
      value = _useDebouncedGridValu2[0],
      setValue = _useDebouncedGridValu2[1];

  var column = props.column;
  var isCurrency = column.type === DataColumnType.Currency;
  var decimalScale = (_ref2 = (_column$config3 = column.config) === null || _column$config3 === void 0 ? void 0 : _column$config3.decimalScale) !== null && _ref2 !== void 0 ? _ref2 : isCurrency ? 2 : 5;
  return React__default.createElement(StyledNumberEditorWrapper, {
    readOnly: column.readOnly
  }, React__default.createElement(NumberFormat, {
    readOnly: column.readOnly,
    thousandSeparator: true,
    decimalScale: decimalScale,
    value: value,
    prefix: isCurrency ? "$" : undefined,
    fixedDecimalScale: isCurrency ? true : false,
    onValueChange: function onValueChange(_ref3) {
      var _ref4, _column$config4, _column$config4$setCe;

      var floatValue = _ref3.floatValue;
      setValue((_ref4 = (_column$config4 = column.config) === null || _column$config4 === void 0 ? void 0 : (_column$config4$setCe = _column$config4.setCellValue) === null || _column$config4$setCe === void 0 ? void 0 : _column$config4$setCe.call(_column$config4, floatValue)) !== null && _ref4 !== void 0 ? _ref4 : floatValue);
    },
    isAllowed: function isAllowed(values) {
      var _column$config5, _column$config6;

      var floatValue = values.floatValue;
      if (((_column$config5 = column.config) === null || _column$config5 === void 0 ? void 0 : _column$config5.min) !== undefined && floatValue < column.config.min) return false;
      if (((_column$config6 = column.config) === null || _column$config6 === void 0 ? void 0 : _column$config6.max) !== undefined && floatValue > column.config.max) return false;
      return true;
    }
  }));
};
var StyledNumberEditorWrapper =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$1(), function (props) {
  return props.readOnly ? "#eee" : "#fff";
}, function (props) {
  return props.readOnly ? "no-drop" : "text";
}, function (props) {
  return props.readOnly ? "none" : "#66afe9";
}, function (props) {
  return props.readOnly ? "none" : "inset 0 1px 1px rgba(0, 0, 0, 0.075),\n      0 0 8px rgba(102, 175, 233, 0.6);";
});
var NumberFormatProvider = function NumberFormatProvider() {
  var _useTableContext2 = useTableContext(),
      columns = _useTableContext2.columns;

  return useMemo(function () {
    return React__default.createElement(DataTypeProvider, {
      formatterComponent: NumberFormatter,
      editorComponent: NumberEditor,
      "for": columns.filter(function (column) {
        return column.type === DataColumnType.Number || column.type === DataColumnType.Currency;
      }).map(function (column) {
        return column.name;
      })
    });
  }, [columns]);
};

var DateEditor = function DateEditor(props) {
  var value = props.value,
      onValueChange = props.onValueChange;
  var column = props.column;
  var includeTime = column.type === DataColumnType.DateTime;
  var dateValue = value ? moment(value).toDate() : undefined;
  var format = includeTime ? "M/DD/YY h:mm A" : "M/DD/YY";
  return React__default.createElement(DateTimeEditorContainer, null, React__default.createElement(DateTimePicker, {
    time: includeTime,
    value: dateValue,
    currentDate: includeTime && !dateValue ? moment().set("hour", 8).set("minute", 0).toDate() : undefined,
    onCurrentDateChange: function onCurrentDateChange(newValue) {
      onValueChange(newValue && newValue.toISOString());
    },
    onChange: function onChange(newValue) {
      onValueChange(newValue && newValue.toISOString());
    },
    disabled: column.readOnly,
    readOnly: column.readOnly,
    format: format,
    parse: parse
  }));
};

var parse = function parse(stringValue) {
  var dateValue = moment(stringValue);

  if (dateValue.isValid()) {
    return dateValue.toDate();
  } // @ts-ignore


  return null;
};

var DateTimeEditorContainer =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject2());
function normalizeDate(rawValue, convertFromUtc, ignoreTimezone) {
  if (convertFromUtc === void 0) {
    convertFromUtc = false;
  }

  if (ignoreTimezone === void 0) {
    ignoreTimezone = false;
  }

  if (ignoreTimezone) {
    /* Turn the string "2019-06-01T00:00:00Z" into something more like "2019-06-01T05:00:00.000Z".
     *
     * The estimates system passes around dates as though they were date-times. This is a problem because
     * the bid date will come in as something equivalent to "midnight UTC on June 1st, 2019". When that
     * string gets turned into a Date (i.e., new Date(...)), javascript automatically takes that to mean
     * "7pm CDT on May 31st, 2019" which is not the date that we want at all. This function turns "7pm
     * CDT on May 31st, 2019" into "midnight CDT on June 1st, 2019" instead.
     * */
    var value = moment(rawValue);
    return value.subtract(value.utcOffset(), "m");
  }

  var dateValue = convertFromUtc ? moment.utc(rawValue).local() : moment(rawValue);
  return dateValue;
}
var DateFormatter = function DateFormatter(props) {
  var value = props.value;
  var column = props.column;

  if (value) {
    var dateValue = normalizeDate(value, column.config && column.config.utc);

    if (dateValue.isValid()) {
      return React__default.createElement(DateTimeContainer, null, React__default.createElement(DateContainer, null, React__default.createElement("div", {
        "data-testid": "table-cell-date-formatted"
      }, dateValue.format("L"))), column.type === DataColumnType.DateTime && React__default.createElement("div", {
        "data-testid": "table-cell-time-formatted"
      }, dateValue.format("LT")));
    }
  }

  return null;
};
var DateTimeContainer =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject3());
var DateContainer =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject4());
var DateFormatProvider = function DateFormatProvider() {
  var _useTableContext3 = useTableContext(),
      columns = _useTableContext3.columns;

  return useMemo(function () {
    return React__default.createElement(DataTypeProvider, {
      formatterComponent: DateFormatter,
      editorComponent: DateEditor,
      "for": columns.filter(function (column) {
        return column.type === DataColumnType.Date || column.type === DataColumnType.DateTime;
      }).map(function (column) {
        return column.name;
      })
    });
  }, [columns]);
};
var DropDownFormatter = function DropDownFormatter(props) {
  var _column$config7;

  var value = props.value;
  var column = props.column;

  if ((_column$config7 = column.config) === null || _column$config7 === void 0 ? void 0 : _column$config7.showLabelValueInTable) {
    var _column$config$listVa, _column$config$listVa2;

    var labelValue = (_column$config$listVa = column.config.listValues) === null || _column$config$listVa === void 0 ? void 0 : (_column$config$listVa2 = _column$config$listVa.find(function (opt) {
      return opt.value === value;
    })) === null || _column$config$listVa2 === void 0 ? void 0 : _column$config$listVa2.display;
    if (labelValue) return labelValue;
  }

  return value ? value : "";
};
var DropDownEditor = function DropDownEditor(props) {
  var _ref5, _column$config8, _ref6, _column$config10;

  var value = props.value,
      onValueChange = props.onValueChange;
  var column = props.column;

  var _useState = useState((_ref5 = (_column$config8 = column.config) === null || _column$config8 === void 0 ? void 0 : _column$config8.listValues) !== null && _ref5 !== void 0 ? _ref5 : []),
      options = _useState[0],
      setOptions = _useState[1];

  var data = options;
  var sortedData = useMemo(function () {
    var _column$config9;

    if (!((_column$config9 = column.config) === null || _column$config9 === void 0 ? void 0 : _column$config9.customSort)) {
      return sortBy(data, function (opt) {
        return opt.display.toLocaleLowerCase();
      });
    }

    return data;
  }, [column.config, data]);

  if (value) {
    sortedData = sortedData.concat([{
      display: "(clear)",
      value: undefined
    }]);
  }

  var allowCreate = (_ref6 = (_column$config10 = column.config) === null || _column$config10 === void 0 ? void 0 : _column$config10.dynamic) !== null && _ref6 !== void 0 ? _ref6 : false;
  var addFieldValue = useCallback(function (newValue) {
    var _newValue$trim;

    if ((newValue === null || newValue === void 0 ? void 0 : (_newValue$trim = newValue.trim) === null || _newValue$trim === void 0 ? void 0 : _newValue$trim.call(newValue)) !== "") {
      setOptions([].concat(options, [{
        display: newValue,
        value: newValue
      }]));
    }
  }, [options]);
  return useMemo(function () {
    var _column$readOnly;

    return React__default.createElement(DropdownContainer, null, React__default.createElement(DropdownList, {
      value: value,
      disabled: (_column$readOnly = column.readOnly) !== null && _column$readOnly !== void 0 ? _column$readOnly : false,
      filter: "contains",
      data: sortedData,
      textField: "display",
      valueField: "value",
      onChange: function onChange(newValue) {
        return onValueChange(newValue && newValue.value ? newValue.value : undefined);
      },
      allowCreate: allowCreate,
      onCreate: allowCreate ? function (newValue) {
        addFieldValue(newValue);

        if (newValue) {
          onValueChange(newValue);
        }
      } : undefined,
      messages: {
        emptyList: "",
        createOption: "To add a new option: type a value, press Enter"
      }
    }));
  }, [addFieldValue, allowCreate, column.readOnly, onValueChange, sortedData, value]);
};
var DropDownFormatProvider = function DropDownFormatProvider() {
  var _useTableContext4 = useTableContext(),
      columns = _useTableContext4.columns;

  return useMemo(function () {
    return React__default.createElement(DataTypeProvider, {
      formatterComponent: DropDownFormatter,
      editorComponent: DropDownEditor,
      "for": columns.filter(function (column) {
        return column.type === DataColumnType.List || column.type === DataColumnType.States;
      }).map(function (column) {
        return column.name;
      })
    });
  }, [columns]);
};
var BooleanEditor = function BooleanEditor(_ref7) {
  var value = _ref7.value,
      column = _ref7.column,
      onValueChange = _ref7.onValueChange,
      disabled = _ref7.disabled;
  var col = column;
  var isDisabled = col.readOnly || disabled;
  return React__default.createElement("div", {
    style: {
      textAlign: "center"
    }
  }, React__default.createElement(Checkbox, {
    disabled: isDisabled,
    checked: value,
    onChange: function onChange() {
      return onValueChange(!value);
    }
  }));
};

var BooleanFormatter = function BooleanFormatter(_ref8) {
  var value = _ref8.value;
  var checked = value === true ? true : false;
  return React__default.createElement("div", {
    style: {
      textAlign: "center"
    }
  }, checked && React__default.createElement(Icon, {
    name: "check"
  }));
};

var BooleanFormatProvider = function BooleanFormatProvider() {
  var _useTableContext5 = useTableContext(),
      columns = _useTableContext5.columns;

  return useMemo(function () {
    return React__default.createElement(DataTypeProvider, {
      formatterComponent: BooleanFormatter,
      editorComponent: BooleanEditor,
      "for": columns.filter(function (column) {
        return column.type === DataColumnType.Boolean;
      }).map(function (column) {
        return column.name;
      })
    });
  }, [columns]);
};

var LinkFormatter = function LinkFormatter(_ref9) {
  var _typedColumn$config, _typedColumn$config2;

  var column = _ref9.column,
      row = _ref9.row,
      value = _ref9.value;

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  if (!row) {
    return value;
  }

  var typedColumn = column;

  if ((_typedColumn$config = typedColumn.config) === null || _typedColumn$config === void 0 ? void 0 : _typedColumn$config.getCellRoute) {
    return React__default.createElement(Link, {
      to: typedColumn.config.getCellRoute({
        column: typedColumn,
        row: row,
        value: value
      })
    }, value);
  }

  if ((_typedColumn$config2 = typedColumn.config) === null || _typedColumn$config2 === void 0 ? void 0 : _typedColumn$config2.baseRoute) {
    return React__default.createElement(Link, {
      to: typedColumn.config.baseRoute + row.id
    }, value);
  }

  return React__default.createElement(Link, {
    to: pathname + "/" + row.id
  }, value);
};

var LinkProvider = function LinkProvider() {
  var _useTableContext6 = useTableContext(),
      columns = _useTableContext6.columns;

  return useMemo(function () {
    return React__default.createElement(DataTypeProvider, {
      formatterComponent: LinkFormatter,
      "for": columns.filter(function (column) {
        var _column$config11;

        return (_column$config11 = column.config) === null || _column$config11 === void 0 ? void 0 : _column$config11.link;
      }).map(function (column) {
        return column.name;
      })
    });
  }, [columns]);
};

var HyperLinksFormatter = function HyperLinksFormatter(_ref10) {
  var value = _ref10.value;

  if (!value || value === "") {
    return React__default.createElement("div", null);
  }

  return React__default.createElement("a", {
    href: value.indexOf("://") === -1 ? "https://" + value : value,
    target: "_blank",
    rel: "noopener noreferrer"
  }, value);
};

var HyperLinksProvider = function HyperLinksProvider() {
  var _useTableContext7 = useTableContext(),
      columns = _useTableContext7.columns;

  return useMemo(function () {
    return React__default.createElement(DataTypeProvider, {
      formatterComponent: HyperLinksFormatter,
      "for": columns.filter(function (column) {
        return column.type === DataColumnType.Links;
      }).map(function (column) {
        return column.name;
      })
    });
  }, [columns]);
};
var DropdownContainer =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject5(), function (props) {
  return props.hasErrors ? "border: 1px solid #a94442;" : "";
});
function useDebouncedGridValue(initialValue, onValueChange, delay) {
  if (delay === void 0) {
    delay = 150;
  }

  var _useState2 = useState(initialValue),
      value = _useState2[0],
      setValue = _useState2[1];

  var debouncedOnValueChange = useCallback(debounce(onValueChange, delay), [onValueChange]);
  useEffect(function () {
    if (initialValue !== value) {
      debouncedOnValueChange(value);
    }
  }, [debouncedOnValueChange, value, initialValue]);
  return [value, setValue];
}

var TableColumnReordering = function TableColumnReordering(props) {
  var _useTableContext = useTableContext(),
      _useTableContext$orde = _useTableContext.order,
      columnOrder = _useTableContext$orde.columnOrder,
      setColumnOrder = _useTableContext$orde.setColumnOrder,
      columns = _useTableContext.columns;

  return useMemo(function () {
    // console.log("order");
    var defaultColumnOrder = createDefaultColumnOrder(columns, columnOrder);
    return createElement(TableColumnReordering$1, Object.assign({
      order: defaultColumnOrder,
      onOrderChange: setColumnOrder
    }, props));
  }, [columnOrder, columns, setColumnOrder, props]);
};
var ColumnReordering = TableColumnReordering;

var TableColumnResizing = function TableColumnResizing(props) {
  var _useTableContext = useTableContext(),
      _useTableContext$sizi = _useTableContext.sizing,
      columnWidths = _useTableContext$sizi.columnWidths,
      setColumnWidths = _useTableContext$sizi.setColumnWidths;

  return useMemo(function () {
    // console.log("sizing");
    return createElement(TableColumnResizing$1, Object.assign({
      columnWidths: columnWidths,
      onColumnWidthsChange: setColumnWidths
    }, props));
  }, [columnWidths, setColumnWidths, props]);
};
var ColumnResizing = TableColumnResizing;

var TableColumnVisibility = function TableColumnVisibility(props) {
  var _useTableContext = useTableContext(),
      _useTableContext$visi = _useTableContext.visibility,
      hiddenColumns = _useTableContext$visi.hiddenColumns,
      setHiddenColumns = _useTableContext$visi.setHiddenColumns,
      columnLookup = _useTableContext.columnLookup;

  return useMemo(function () {
    // console.log("visibility");
    return createElement(TableColumnVisibility$1, Object.assign({
      hiddenColumnNames: hiddenColumns.filter(function (col) {
        var _columnLookup$col;

        return (_columnLookup$col = columnLookup[col]) === null || _columnLookup$col === void 0 ? void 0 : _columnLookup$col.hidingEnabled;
      }),
      onHiddenColumnNamesChange: setHiddenColumns
    }, props));
  }, [hiddenColumns, setHiddenColumns, props, columnLookup]);
};
var ColumnVisibility = TableColumnVisibility;

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  font-size: 1.22rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: rgb(64, 64, 64);\n  padding: 3px 20px;\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  z-index: 20000;\n  &,\n  & .react-contextmenu {\n    min-width: 160px;\n    padding: 5px 0;\n    margin: 2px 0 0;\n    font-size: 14px;\n    text-align: left;\n    list-style: none;\n    background-color: #fff;\n    -webkit-background-clip: padding-box;\n    background-clip: padding-box;\n    border: 1px solid #ccc;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-radius: 4px;\n    -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  }\n\n  & .react-contextmenu-item {\n    &:hover {\n      background-color: #f5f5f5;\n    }\n    padding: 3px 20px;\n    font-weight: 400;\n    line-height: 1.42857143;\n    color: #333;\n    z-index: 20001;\n    cursor: pointer;\n  }\n\n  & .react-contextmenu-submenu {\n    padding: 0;\n  }\n\n  & nav.react-contextmenu-submenu nav {\n    display: none;\n  }\n\n  & nav.react-contextmenu-submenu nav.react-contextmenu--visible {\n    display: initial;\n  }\n\n  & .react-contextmenu-item--divider {\n    border-bottom: 1px solid #d6d6d6;\n    padding: 0px;\n    margin: 4px 0px;\n\n    &:hover {\n      background-color: #fff;\n    }\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var WrappedContextMenu =
/*#__PURE__*/
styled(ContextMenu)(
/*#__PURE__*/
_templateObject$2());
var StyledContextMenu = function StyledContextMenu(props) {
  return React__default.createElement(WrappedContextMenu, Object.assign({}, props));
};
var MenuItemHeader =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject2$1());

function useContextMenu() {
  var _useTableContext = useTableContext(),
      columnLookup = _useTableContext.columnLookup,
      _useTableContext$visi = _useTableContext.visibility,
      hiddenColumns = _useTableContext$visi.hiddenColumns,
      setHiddenColumns = _useTableContext$visi.setHiddenColumns,
      _useTableContext$grou = _useTableContext.grouping,
      grouping = _useTableContext$grou.grouping,
      setGrouping = _useTableContext$grou.setGrouping,
      _useTableContext$sort = _useTableContext.sorting,
      sorting = _useTableContext$sort.sorting,
      setSorting = _useTableContext$sort.setSorting,
      setShowModal = _useTableContext.columnSelect.setShowModal,
      _useTableContext$colo = _useTableContext.coloring,
      setColoringColumnName = _useTableContext$colo.setColoringColumnName,
      coloringColumnName = _useTableContext$colo.coloringColumnName,
      columns = _useTableContext.columns;

  var handleHide = function handleHide(e, passed) {
    var newHiddenColumns = [].concat(hiddenColumns);

    if (newHiddenColumns.indexOf(passed.name) === -1) {
      newHiddenColumns.push(passed.name);
      setHiddenColumns(newHiddenColumns);
    }
  };

  var handleGroup = function handleGroup(e, passed, config) {
    var newGrouping = [].concat(grouping);
    newGrouping.push({
      columnName: passed.name,
      config: (config === null || config === void 0 ? void 0 : config.dateGrouping) ? config : undefined
    });
    setGrouping(newGrouping);
  };

  var nextSortingDescription = function nextSortingDescription(columnName) {
    var sortingValue = nextSortingValue(columnName);

    if (sortingValue === "asc") {
      return "Ascending";
    }

    return "Descending";
  };

  function nextSortingValue(columnName) {
    var existingSorting = find(sorting, function (s) {
      return s.columnName === columnName;
    });

    if (existingSorting && existingSorting.direction === "asc") {
      return "desc";
    }

    return "asc";
  }

  var handleSort = function handleSort(e, passed) {
    var newSorting = {
      columnName: passed.name,
      direction: nextSortingValue(passed.name)
    };
    setSorting([newSorting]);
  };

  var handleSelectColumns = function handleSelectColumns() {
    setShowModal(true);
  };

  var groupingEnabled = function groupingEnabled(name) {
    var _columnLookup$name;

    var column = columnLookup[name];

    if (!column) {
      return false;
    }

    if (!((_columnLookup$name = columnLookup[name]) === null || _columnLookup$name === void 0 ? void 0 : _columnLookup$name.groupingEnabled)) {
      return false;
    }

    if (column.type === DataColumnType.Links) {
      return false;
    }

    if (column.type === DataColumnType.CheckList) {
      return false;
    } // don't allow grouping if it's the last visible column in the table


    if (columns.length - hiddenColumns.length - grouping.length <= 1) {
      return false;
    }

    return true;
  };

  var handleHighlight = function handleHighlight(e, passed) {
    isHighlightedColumn(passed.name) ? setColoringColumnName("") : setColoringColumnName(passed.name);
  };

  var isHighlightedColumn = function isHighlightedColumn(columnName) {
    return columnName === coloringColumnName;
  };

  var getColumn = function getColumn(columnName) {
    return columnLookup[columnName];
  };

  return {
    handleHide: handleHide,
    handleSort: handleSort,
    handleGroup: handleGroup,
    handleSelectColumns: handleSelectColumns,
    handleHighlight: handleHighlight,
    isHighlightedColumn: isHighlightedColumn,
    getColumn: getColumn,
    groupingEnabled: groupingEnabled,
    nextSortingValue: nextSortingValue,
    nextSortingDescription: nextSortingDescription
  };
}

var HeaderMenuItems = function HeaderMenuItems(_ref) {
  var _ref2, _messages$highlight, _ref3, _messages$highlight2, _ref6;

  var columnName = _ref.columnName,
      messages = _ref.messages,
      _ref$menuItems = _ref.menuItems,
      menuItems = _ref$menuItems === void 0 ? {} : _ref$menuItems;
  var _menuItems$showGroupi = menuItems.showGrouping,
      showGrouping = _menuItems$showGroupi === void 0 ? true : _menuItems$showGroupi,
      _menuItems$showSortin = menuItems.showSorting,
      showSorting = _menuItems$showSortin === void 0 ? true : _menuItems$showSortin,
      _menuItems$showVisibi = menuItems.showVisibility,
      showVisibility = _menuItems$showVisibi === void 0 ? true : _menuItems$showVisibi,
      _menuItems$showHighli = menuItems.showHighlight,
      showHighlight = _menuItems$showHighli === void 0 ? true : _menuItems$showHighli;

  var _useContextMenu = useContextMenu(),
      handleGroup = _useContextMenu.handleGroup,
      handleHide = _useContextMenu.handleHide,
      handleSort = _useContextMenu.handleSort,
      groupingEnabled = _useContextMenu.groupingEnabled,
      nextSortingValue = _useContextMenu.nextSortingValue,
      getColumn = _useContextMenu.getColumn,
      handleHighlight = _useContextMenu.handleHighlight,
      isHighlightedColumn = _useContextMenu.isHighlightedColumn;

  var column = getColumn(columnName);

  if (!column) {
    return null;
  }

  var highlightable = column.type === DataColumnType.List || column.type === DataColumnType.States;
  var highlightMenuLabel = isHighlightedColumn(columnName) ? (_ref2 = messages === null || messages === void 0 ? void 0 : (_messages$highlight = messages.highlight) === null || _messages$highlight === void 0 ? void 0 : _messages$highlight.off) !== null && _ref2 !== void 0 ? _ref2 : "Clear Highlight" : (_ref3 = messages === null || messages === void 0 ? void 0 : (_messages$highlight2 = messages.highlight) === null || _messages$highlight2 === void 0 ? void 0 : _messages$highlight2.on) !== null && _ref3 !== void 0 ? _ref3 : "Highlight";

  var getSortString = function getSortString() {
    var _ref5;

    var sortValue = nextSortingValue(columnName);

    if (sortValue === "asc") {
      var _ref4;

      return (_ref4 = messages === null || messages === void 0 ? void 0 : messages.sortAscending) !== null && _ref4 !== void 0 ? _ref4 : "Sort Ascending";
    }

    return (_ref5 = messages === null || messages === void 0 ? void 0 : messages.sortDescending) !== null && _ref5 !== void 0 ? _ref5 : "Sort Descending";
  };

  return createElement(Fragment, null, createElement(MenuItemHeader, null, column.title), showSorting && createElement(MenuItem, {
    onClick: handleSort
  }, getSortString()), showGrouping && groupingEnabled(column.name) && createElement(GroupMenu, {
    handleGroup: handleGroup,
    column: column,
    messages: messages
  }), showHighlight && highlightable && createElement(MenuItem, {
    onClick: handleHighlight
  }, highlightMenuLabel), showVisibility && column.hidingEnabled && createElement(MenuItem, {
    onClick: handleHide
  }, (_ref6 = messages === null || messages === void 0 ? void 0 : messages.hide) !== null && _ref6 !== void 0 ? _ref6 : "Hide"));
};

var GroupMenu = function GroupMenu(_ref7) {
  var _ref14;

  var column = _ref7.column,
      handleGroup = _ref7.handleGroup,
      messages = _ref7.messages;

  if (column.type === DataColumnType.DateTime || column.type === DataColumnType.Date) {
    var _ref8, _ref9, _messages$dateGroupin, _ref10, _messages$dateGroupin2, _ref11, _messages$dateGroupin3, _ref12, _messages$dateGroupin4, _ref13, _messages$dateGroupin5;

    return (// @ts-ignore
      createElement(SubMenu, {
        title: createElement("div", {
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "baseline"
          }
        }, createElement("span", null, (_ref8 = messages === null || messages === void 0 ? void 0 : messages.group) !== null && _ref8 !== void 0 ? _ref8 : "Group"), createElement(Icon, {
          name: "chevron-right",
          style: {
            position: "relative",
            right: "-15px"
          }
        }))
      }, createElement(MenuItem, {
        onClick: function onClick(e, passed) {
          return handleGroup(e, passed, {
            dateGrouping: "year"
          });
        }
      }, (_ref9 = messages === null || messages === void 0 ? void 0 : (_messages$dateGroupin = messages.dateGrouping) === null || _messages$dateGroupin === void 0 ? void 0 : _messages$dateGroupin.year) !== null && _ref9 !== void 0 ? _ref9 : "Year"), createElement(MenuItem, {
        onClick: function onClick(e, passed) {
          handleGroup(e, passed, {
            dateGrouping: "quarter"
          });
        }
      }, (_ref10 = messages === null || messages === void 0 ? void 0 : (_messages$dateGroupin2 = messages.dateGrouping) === null || _messages$dateGroupin2 === void 0 ? void 0 : _messages$dateGroupin2.quarter) !== null && _ref10 !== void 0 ? _ref10 : "Quarter"), createElement(MenuItem, {
        onClick: function onClick(e, passed) {
          return handleGroup(e, passed, {
            dateGrouping: "month"
          });
        }
      }, (_ref11 = messages === null || messages === void 0 ? void 0 : (_messages$dateGroupin3 = messages.dateGrouping) === null || _messages$dateGroupin3 === void 0 ? void 0 : _messages$dateGroupin3.month) !== null && _ref11 !== void 0 ? _ref11 : "Month"), createElement(MenuItem, {
        onClick: function onClick(e, passed) {
          return handleGroup(e, passed, {
            dateGrouping: "week"
          });
        }
      }, (_ref12 = messages === null || messages === void 0 ? void 0 : (_messages$dateGroupin4 = messages.dateGrouping) === null || _messages$dateGroupin4 === void 0 ? void 0 : _messages$dateGroupin4.week) !== null && _ref12 !== void 0 ? _ref12 : "Week"), createElement(MenuItem, {
        onClick: function onClick(e, passed) {
          return handleGroup(e, passed, {
            dateGrouping: "day"
          });
        }
      }, (_ref13 = messages === null || messages === void 0 ? void 0 : (_messages$dateGroupin5 = messages.dateGrouping) === null || _messages$dateGroupin5 === void 0 ? void 0 : _messages$dateGroupin5.day) !== null && _ref13 !== void 0 ? _ref13 : "Day"))
    );
  }

  return createElement(MenuItem, {
    onClick: handleGroup
  }, (_ref14 = messages === null || messages === void 0 ? void 0 : messages.group) !== null && _ref14 !== void 0 ? _ref14 : "Group");
}; // quick filter based on type (e.g. string "Add 'road' to current filters,
// date "show projects within 7 days of filter")

var TableMenuItems = function TableMenuItems(_ref) {
  var _ref2;

  var messages = _ref.messages,
      _ref$menuItems = _ref.menuItems,
      menuItems = _ref$menuItems === void 0 ? {} : _ref$menuItems;
  var _menuItems$showVisibi = menuItems.showVisibility,
      showVisibility = _menuItems$showVisibi === void 0 ? true : _menuItems$showVisibi;

  var _useContextMenu = useContextMenu(),
      handleSelectColumns = _useContextMenu.handleSelectColumns;

  return createElement(Fragment, null, showVisibility && createElement(MenuItem, {
    onClick: handleSelectColumns
  }, (_ref2 = messages === null || messages === void 0 ? void 0 : messages.showHideColumns) !== null && _ref2 !== void 0 ? _ref2 : "Show/Hide Columns"));
}; // quick filter based on type (e.g. string "Add 'road' to current filters,
// date "show projects within 7 days of filter")

var HeaderContextMenu =
/*#__PURE__*/
connectMenu("headerclick")(function (_ref) {
  var _ref2, _ref3;

  var trigger = _ref.trigger,
      headerMenuMessages = _ref.headerMenuMessages,
      tableMenuMessages = _ref.tableMenuMessages,
      headerMenuItems = _ref.headerMenuItems,
      tableMenuItems = _ref.tableMenuItems;
  var showHeaderMenuItems = (_ref2 = trigger === null || trigger === void 0 ? void 0 : trigger.name) !== null && _ref2 !== void 0 ? _ref2 : false;
  var showTableMenuItems = (_ref3 = tableMenuItems === null || tableMenuItems === void 0 ? void 0 : tableMenuItems.showVisibility) !== null && _ref3 !== void 0 ? _ref3 : true; // TODO: not expandable

  return createElement(StyledContextMenu, {
    id: "headerclick"
  }, showHeaderMenuItems && createElement(HeaderMenuItems, {
    columnName: showHeaderMenuItems,
    messages: headerMenuMessages,
    menuItems: headerMenuItems
  }), showHeaderMenuItems && showTableMenuItems && createElement(MenuItem, {
    divider: true
  }), showTableMenuItems && createElement(TableMenuItems, {
    menuItems: tableMenuItems,
    messages: tableMenuMessages
  }));
}); // quick filter based on type (e.g. string "Add 'road' to current filters,
// date "show projects within 7 days of filter")

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  text-align: center;\n  white-space: nowrap;\n  overflow: visible;\n  text-overflow: ellipsis;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 5px 10px;\n  cursor: pointer;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  &.btn {\n    padding: 4px 12px;\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var commandComponentProps = {
  add: {
    icon: "plus",
    text: "Add",
    hint: "Add Entry"
  },
  edit: {
    text: "",
    icon: "pencil",
    hint: "Edit Entry"
  },
  "delete": {
    icon: "trash-o",
    hint: "Delete Entry",
    isDanger: true,
    text: ""
  },
  commit: {
    icon: "save",
    text: "",
    hint: "Save changes"
  },
  cancel: {
    icon: "undo",
    hint: "Cancel changes",
    text: ""
  }
};
var CommandButton = function CommandButton(_ref) {
  var onExecute = _ref.onExecute,
      icon = _ref.icon,
      text = _ref.text,
      hint = _ref.hint,
      isDanger = _ref.isDanger,
      id = _ref.id,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      props = _objectWithoutPropertiesLoose(_ref, ["onExecute", "icon", "text", "hint", "isDanger", "id", "disabled"]);

  var children;

  if (id === "add") {
    children = createElement(TableAddButton, {
      onClick: onExecute,
      title: hint,
      disabled: disabled
    }, icon && createElement(Icon, {
      name: icon,
      margin: "right"
    }), text);
  } else if (id === "commit") {
    children = createElement(RowCommandButton, {
      className: isDanger ? "text-danger" : undefined,
      onClick: function onClick(e) {
        if (props.validationFunction) {
          var valid = props.validationFunction(props.tableRow);

          if (!valid) {
            return;
          }
        }

        onExecute();
        e.stopPropagation();
      },
      title: hint
    }, icon && createElement(Icon, {
      name: icon,
      margin: text ? "right" : undefined
    }));
  } else {
    children = createElement(RowCommandButton, {
      className: isDanger ? "text-danger" : undefined,
      onClick: !disabled ? onExecute : undefined,
      title: hint
    }, icon && createElement(Icon, {
      name: icon,
      margin: text ? "right" : undefined,
      style: {
        color: disabled ? "#CCCCCC" : "inherit"
      }
    }));
  }

  return children;
};
var CommandComponent = function CommandComponent(props) {
  return createElement(CommandButton, Object.assign({}, props, commandComponentProps[props.id]));
};
var EditCellComponent = function EditCellComponent(props) {
  return createElement("td", null, createElement(WrapperDiv, null, createElement(InnerDiv, null, Children.map(props.children, function (child) {
    return isValidElement(child) ? cloneElement(child, _extends({}, child.props, {
      tableRow: props.tableRow
    })) : child;
  }))));
};
var TableAddButton =
/*#__PURE__*/
styled(Button)(
/*#__PURE__*/
_templateObject$3());
var EditCellHeaderComponent = function EditCellHeaderComponent(props) {
  return createElement("th", {
    style: {
      padding: "4px"
    }
  }, createElement(WrapperDiv, null, createElement(InnerDiv, null, props.children)));
};
var RowCommandButton =
/*#__PURE__*/
styled.span(
/*#__PURE__*/
_templateObject2$2());
var WrapperDiv =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject3$1());
var InnerDiv =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject4$1());

var IntegratedFiltering = function IntegratedFiltering(props) {
  var _useTableContext = useTableContext(),
      columns = _useTableContext.columns;

  return useMemo(function () {
    return createElement(IntegratedFiltering$1, Object.assign({
      columnExtensions: columns.filter(function (c) {
        return c.type === DataColumnType.Links || c.type === DataColumnType.CheckList || c.type === DataColumnType.Custom;
      }).map(function (c) {
        return {
          columnName: c.name,
          predicate: function predicate(value, filter) {
            if (c.type === DataColumnType.Links) {
              return linkToString(value).toUpperCase().indexOf(filter.value.toUpperCase()) > -1;
            }

            if (c.type === DataColumnType.CheckList) {
              return checkListToString(value).toUpperCase().indexOf(filter.value.toUpperCase()) > -1;
            }

            if (c.type === DataColumnType.Custom && c.config) {
              return c.config.valueAsString(value).toUpperCase().indexOf(filter.value.toUpperCase()) > -1;
            }

            return true;
          }
        };
      })
    }, props));
  }, [columns, props]);
};

var linkToString = function linkToString(value) {
  var retString = "";

  if (value) {
    value.forEach(function (link, index) {
      retString += index > 0 ? ", " : "";
      retString += link.description || link.url;
    });
  }

  return retString;
};

var checkListToString = function checkListToString(value) {
  var retString = "";

  if (value) {
    value.forEach(function (list, index) {
      retString += index > 0 ? ", " : "";
      retString += list.checked ? "Checked " : "Not Checked ";
      retString += list.description;
    });
  }

  return retString;
};

var FilteringState = function FilteringState(props) {
  var _useTableContext = useTableContext(),
      _useTableContext$filt = _useTableContext.filtering,
      filters = _useTableContext$filt.filters,
      setFilters = _useTableContext$filt.setFilters;

  return useMemo(function () {
    // console.log("filtering");
    return createElement(FilteringState$1, Object.assign({
      filters: filters,
      onFiltersChange: setFilters
    }, props));
  }, [filters, setFilters, props]);
};

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: 700;\n  padding-right: 20px;\n  background-color: #fff;\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  position: sticky;\n  left: 0px;\n  background: rgb(255, 255, 255);\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 1) 0%,\n    rgba(255, 255, 255, 1) 25%,\n    rgba(255, 255, 255, 0) 25%\n  );\n\n  & span strong {\n    font-weight: 400;\n  }\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var GroupCell = function GroupCell(props) {
  return createElement(StyledGroupCell, Object.assign({}, props), createElement(Bold, null, props.row.key));
};
var StyledGroupCell =
/*#__PURE__*/
styled(TableGroupRow$1.Cell)(
/*#__PURE__*/
_templateObject$4());
var Bold =
/*#__PURE__*/
styled.span(
/*#__PURE__*/
_templateObject2$3());

var IntegratedGrouping = function IntegratedGrouping(_ref) {
  var columnOverrides = _ref.columnOverrides,
      typeOverrides = _ref.typeOverrides,
      other = _objectWithoutPropertiesLoose(_ref, ["columnOverrides", "typeOverrides"]);

  var _useTableContext = useTableContext(),
      columns = _useTableContext.columns;

  return useMemo(function () {
    // console.log("grouping extensions");
    var extensions = generateGroupingExtensions(columns, columnOverrides, typeOverrides);
    return createElement(IntegratedGrouping$1, Object.assign({
      columnExtensions: extensions
    }, other));
  }, [columns, columnOverrides, typeOverrides, other]);
};
function generateGroupingExtensions(columns, columnOverrides, typeOverrides) {
  return columns.map(function (column) {
    var _ref2, _ref3;

    var criteria = (_ref2 = (_ref3 = columnOverrides === null || columnOverrides === void 0 ? void 0 : columnOverrides[column.name]) !== null && _ref3 !== void 0 ? _ref3 : typeOverrides === null || typeOverrides === void 0 ? void 0 : typeOverrides[column.type]) !== null && _ref2 !== void 0 ? _ref2 : getGroupingFunction(column);
    return {
      columnName: column.name,
      criteria: criteria
    };
  });
}
function getGroupingFunction(_ref4) {
  var _ref5;

  var type = _ref4.type,
      config = _ref4.config;

  switch (type) {
    case DataColumnType.Boolean:
      return groupBoolean;

    case DataColumnType.Currency:
      return groupCurrency;

    case DataColumnType.Number:
      return groupNumber;

    case DataColumnType.Date:
    case DataColumnType.DateTime:
      return groupDate.bind(null, (_ref5 = config === null || config === void 0 ? void 0 : config.dateGrouping) !== null && _ref5 !== void 0 ? _ref5 : "quarter");

    case DataColumnType.Custom:
      return groupCustom.bind(null, config === null || config === void 0 ? void 0 : config.valueAsString);

    default:
      return groupString;
  }
}

function groupBoolean(value) {
  if (value === void 0) {
    value = false;
  }

  if (value) {
    return {
      key: "Checked",
      value: "Checked"
    };
  }

  return {
    key: "Not Checked",
    value: "Not Checked"
  };
}

function groupDate(interval, value) {
  if (value) {
    var dateValue = moment(value);

    if (dateValue.isValid()) {
      var label = getDateGroupLabel(dateValue, interval);
      return {
        key: label,
        value: label
      };
    }
  }

  return {
    key: ""
  };
}

function getDateGroupLabel(value, interval) {
  switch (interval) {
    case "year":
      {
        return value.startOf(interval).format("YYYY");
      }

    case "month":
      {
        return value.startOf(interval).format("MMMM YYYY");
      }

    case "quarter":
      {
        return value.startOf(interval).format("MMMM YYYY") + " - " + value.endOf(interval).format("MMMM YYYY");
      }

    case "week":
      {
        return value.startOf(interval).format("L") + " - " + value.endOf(interval).format("L");
      }

    case "day":
      {
        return "" + value.startOf(interval).format("L");
      }

    default:
      {
        return value.startOf(interval).format("L") + " - " + value.endOf(interval).format("L");
      }
  }
}

function groupNumber(value) {
  if (value !== undefined && value !== null) {
    return {
      key: numeral(value).format()
    };
  }

  return {
    key: ""
  };
}

function groupCurrency(value) {
  if (value !== undefined && value !== null) {
    return {
      key: numeral(value).format("$0,0.00")
    };
  }

  return {
    key: ""
  };
}

function groupString(value) {
  return {
    key: value || ""
  };
}

function groupCustom(valueAsString, value) {
  var _ref6;

  return {
    key: (_ref6 = valueAsString === null || valueAsString === void 0 ? void 0 : valueAsString(value)) !== null && _ref6 !== void 0 ? _ref6 : ""
  };
}

var GroupingState = function GroupingState(props) {
  var _useTableContext = useTableContext(),
      columns = _useTableContext.columns,
      _useTableContext$grou = _useTableContext.grouping,
      setGrouping = _useTableContext$grou.setGrouping,
      expandedGroups = _useTableContext$grou.expandedGroups,
      setExpandedGroups = _useTableContext$grou.setExpandedGroups,
      extendedGroups = _useTableContext.extendedGroups;

  return useMemo(function () {
    // console.log("grouping");
    var filteredGrouping = filteredGroups(columns, extendedGroups);
    return createElement(GroupingState$1, Object.assign({
      grouping: filteredGrouping,
      onGroupingChange: function onGroupingChange(newGrouping) {
        setGrouping(newGrouping);
      },
      expandedGroups: expandedGroups,
      onExpandedGroupsChange: setExpandedGroups,
      columnExtensions: getGroupingStateExtensions(columns)
    }, props));
  }, [columns, extendedGroups, setGrouping, expandedGroups, setExpandedGroups, props]);
};
var filteredGroups =
/*#__PURE__*/
memoize(function (columns, grouping) {
  var columnNames = columns.map(function (column) {
    return column.name;
  });
  return grouping.filter(function (group) {
    return columnNames.indexOf(group.columnName) > -1;
  });
});
var getGroupingStateExtensions =
/*#__PURE__*/
memoize(function (columns) {
  return columns.filter(function (column) {
    return !column.groupingEnabled || column.type === DataColumnType.Links || column.type === DataColumnType.CheckList;
  }).map(function (column) {
    return {
      columnName: column.name,
      groupingEnabled: false
    };
  });
});

var TableHeaderCell = function TableHeaderCell(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return createElement(TableHeaderRow$1.Cell, Object.assign({}, props), createElement(ContextMenuTrigger, {
    attributes: {
      style: {
        width: "100%"
      }
    },
    id: "headerclick",
    collect: function collect() {
      return {
        name: props.column.name,
        title: props.column.title
      };
    }
  }, children));
};

var TableHeaderRow = function TableHeaderRow(_ref) {
  var headerMenuMessages = _ref.headerMenuMessages,
      tableMenuMessages = _ref.tableMenuMessages,
      tableMenuItems = _ref.tableMenuItems,
      headerMenuItems = _ref.headerMenuItems,
      other = _objectWithoutPropertiesLoose(_ref, ["headerMenuMessages", "tableMenuMessages", "tableMenuItems", "headerMenuItems"]);

  return createElement(Fragment, null, createElement(HeaderContextMenu, {
    headerMenuMessages: headerMenuMessages,
    tableMenuMessages: tableMenuMessages,
    tableMenuItems: tableMenuItems,
    headerMenuItems: headerMenuItems
  }), createElement(TableHeaderRow$1, Object.assign({}, other, {
    cellComponent: TableHeaderCell
  })));
};

var AllRows = function AllRows() {
  return createElement(Plugin, null, createElement(Getter, {
    name: "allRows",
    computed: function computed(_ref) {
      var rows = _ref.rows,
          isGroupRow = _ref.isGroupRow,
          getCollapsedRows = _ref.getCollapsedRows;
      var detailRows = [];
      var groupRows = [];
      var rowsToSearch = [].concat(rows);

      while (rowsToSearch.length > 0) {
        var row = rowsToSearch.shift();

        if (isGroupRow(row)) {
          groupRows.push(row);
          var newRows = getCollapsedRows(row);

          if (newRows && newRows.length > 0) {
            rowsToSearch = newRows.concat(rowsToSearch);
          }
        } else {
          detailRows.push(row);
        }
      }

      return {
        detailRows: detailRows,
        groupRows: groupRows
      };
    }
  }));
};

var highlightProjects = function highlightProjects(_ref6) {
  var tableColumns = _ref6.tableColumns;
  return tableColumns === undefined ? Promise.resolve() : Promise.resolve();
};
var exportCSV = function exportCSV(_ref4, _ref5) {
  var tableColumns = _ref4.tableColumns,
      exportRows = _ref4.exportRows,
      getCellValue = _ref4.getCellValue;
  var filename = _ref5.filename;

  try {
    if (tableColumns === undefined) {
      return Promise.resolve();
    }

    var data = formatExportRows(tableColumns, exportRows, getCellValue);
    return Promise.resolve(import('papaparse')).then(function (Papa) {
      var csv = Papa.unparse(data);
      var blob = new Blob([csv], {
        type: "text/csv;charset=utf-8"
      });
      return Promise.resolve(import('file-saver')).then(function (FileSaver) {
        FileSaver.saveAs(blob, (filename || new Date().toISOString()) + ".csv");
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var exportPDF = function exportPDF(_ref2, _ref3) {
  var tableColumns = _ref2.tableColumns,
      exportRows = _ref2.exportRows,
      getCellValue = _ref2.getCellValue;
  var templateDisplayName = _ref3.templateDisplayName,
      filename = _ref3.filename;

  try {
    if (tableColumns === undefined) {
      return Promise.resolve();
    }

    var dataBody = formatExportRows(tableColumns, exportRows, getCellValue, true);
    return Promise.resolve(import('jspdf-autotable')).then(function () {
      return Promise.resolve(import('jspdf')).then(function (jspdf) {
        var options = {};

        if (tableColumns.length >= 8) {
          options = {
            orientation: "l",
            unit: "mm",
            format: "a3",
            compress: true
          };
        } else {
          options = {
            orientation: "p",
            unit: "mm",
            format: "a4",
            compress: true
          };
        }

        var jsPDF = jspdf["default"];
        var doc = new jsPDF(options);
        var totalPagesExp = "{total_pages_count_string}";
        var headers = [];
        var columnStyles = {};

        if (dataBody[0]) {
          Object.keys(dataBody[0]).forEach(function (headerName) {
            {
              var header = {
                dataKey: headerName,
                header: headerName
              };
              headers.push(header);
              var wrapCol = tableColumns.filter(function (x) {
                return x.column !== undefined && x.column !== null && x.column.title === headerName && x.width >= 250;
              })[0];

              if (wrapCol) {
                // Create columnStyles
                columnStyles[headerName] = {
                  halign: "left",
                  cellWidth: 40
                };
              }

              var rightCol = tableColumns.filter(function (x) {
                return x.column !== undefined && x.column !== null && x.column.title === headerName && x.align === "right";
              })[0];

              if (rightCol) {
                // Create columnStyles
                columnStyles[headerName] = {
                  halign: "right"
                };
              }
            }
          });
        }

        var headStyles = {
          font: "helvetica",
          fontStyle: "bold",
          overflow: "linebreak",
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          halign: "left",
          valign: "middle",
          fontSize: 11,
          cellPadding: 1.5,
          lineColor: [128, 128, 128],
          lineWidth: 0.1,
          cellWidth: "auto",
          minCellHeight: 12
        };
        var bodyStyles = {
          font: "helvetica",
          fontStyle: "normal",
          overflow: "linebreak",
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          halign: "left",
          valign: "middle",
          fontSize: 9,
          cellPadding: 1.5,
          lineColor: [221, 221, 221],
          lineWidth: 0.25,
          cellWidth: "auto",
          minCellHeight: 10
        };
        var alternateRowStyles = {
          font: "helvetica",
          fontStyle: "normal",
          overflow: "linebreak",
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          halign: "left",
          valign: "middle",
          fontSize: 9,
          cellPadding: 1.5,
          lineColor: [221, 221, 221],
          lineWidth: 0.25,
          cellWidth: "auto",
          minCellHeight: 10
        };
        var pdfObject = {
          columns: headers,
          body: dataBody,
          startY: 30,
          columnStyles: columnStyles,
          theme: "striped",
          pageBreak: "auto",
          tableWidth: "auto",
          showHead: "everyPage",
          showFoot: "everyPage",
          margin: {
            top: 30,
            left: 20,
            right: 20,
            bottom: 30
          },
          bodyStyles: bodyStyles,
          headStyles: headStyles,
          alternateRowStyles: alternateRowStyles,
          allSectionHooks: true,
          didDrawPage: function didDrawPage(data) {
            // HEADER
            doc.setFontSize(14);
            doc.setTextColor(40);
            doc.setFontStyle("bold");
            doc.text(templateDisplayName || "", data.settings.margin.left, 16); // set your margins
            // Footer

            var str = "Page " + doc.internal.getNumberOfPages(); // Total page number

            if (typeof doc.putTotalPages === "function") {
              str = str + " of " + totalPagesExp;
            }

            doc.setFontSize(10);
            doc.setTextColor(40);
            doc.setFontStyle("normal");
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text(str, data.settings.margin.left, pageHeight - 18);
            doc.text(new Date().toLocaleString(), data.table.width - 20, pageHeight - 18);
          }
        };
        doc.autoTable(pdfObject); // Total page number plugin only available in jspdf v1.0+

        if (typeof doc.putTotalPages === "function") {
          doc.putTotalPages(totalPagesExp);
        }

        doc.save((filename || new Date().toISOString()) + ".pdf");
      });
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var ExportRows = function ExportRows(_ref) {
  var templateDisplayName = _ref.templateDisplayName,
      filename = _ref.filename;
  return createElement(Plugin, null, createElement(Getter, {
    name: "templateDisplayName",
    value: templateDisplayName
  }), createElement(Getter, {
    name: "filename",
    value: filename
  }), createElement(Action, {
    name: "exportCSV",
    action: exportCSV
  }), createElement(Action, {
    name: "exportPDF",
    action: exportPDF
  }), createElement(Action, {
    name: "highlightProj",
    action: highlightProjects
  }));
};
var formatExportRows = function formatExportRows(tableColumns, exportRows, getCellValue, isPDFExport) {
  if (isPDFExport === void 0) {
    isPDFExport = false;
  }

  var dataColumns = tableColumns.filter(function (tableColumn) {
    return "column" in tableColumn;
  });
  return exportRows.map(function (row) {
    var dataRow = {};
    dataColumns.forEach(function (_ref7) {
      var _column$title;

      var column = _ref7.column;
      var keyExists = ((_column$title = column.title) !== null && _column$title !== void 0 ? _column$title : column.name) in dataRow;
      var key = "" + column.title + (keyExists ? " (2)" : "");
      var value = getCellValue(row, column.name);

      if (column.type === DataColumnType.Date && value && value !== "") {
        var dateValue = moment(value);

        if (dateValue.isValid()) {
          value = isPDFExport ? dateValue.format("L") : dateValue.format("YYYY-MM-DD");
        }
      } else if (column.type === DataColumnType.DateTime && value && value !== "") {
        var _dateValue = moment(value);

        if (_dateValue.isValid()) {
          value = isPDFExport ? _dateValue.format("L LT") : _dateValue.format("YYYY-MM-DD HH:mm");
        }
      } else if (isPDFExport && column.type === DataColumnType.Currency) {
        if (value || value === 0) {
          value = numeral(value).format("$0,0." + "0".repeat(2));
        }
      } else if (isPDFExport && column.type === DataColumnType.Number) {
        if (value) {
          value = value.toString().indexOf(".") !== -1 ? numeral(value).format("0,0." + "0".repeat(2)) : numeral(value).format("0,0." + "0".repeat(0));
        }
      } else if (column.type === DataColumnType.Boolean) {
        if (value && value !== "") {
          value = true;
        } else {
          value = false;
        }
      } else if (column.type === DataColumnType.Custom) {
        var _ref8, _column$config;

        value = (_ref8 = (_column$config = column.config) === null || _column$config === void 0 ? void 0 : _column$config.valueAsString(value)) !== null && _ref8 !== void 0 ? _ref8 : "";
      } else if (column.type === DataColumnType.Links) {
        value = getLinks(value);
      } else if (column.type === DataColumnType.CheckList) {
        value = getCheckList(value);
      }

      dataRow[key] = value;
    });
    return dataRow;
  });
};

var getLinks = function getLinks(value) {
  var link = "";

  if (value && value.length > 0 && Object.keys(value).length > 0) {
    value.forEach(function (val) {
      if (val.url) {
        link += val.url + "; ";
      }
    });
  }

  return link;
};

var getCheckList = function getCheckList(value) {
  var checkListString = "";

  if (value && value.length > 0 && Object.keys(value).length > 0) {
    value.forEach(function (val) {
      checkListString += val.checked ? "Checked - " : "Not Checked - ";
      checkListString += val.description + "; ";
    });
  }

  return checkListString;
};

function getGroupKeys(rows, groups, columns) {
  var groupKeys = {};
  var columnsByName = keyBy(columns, "name");
  var validGroups = groups.filter(function (group) {
    return group.columnName in columnsByName;
  });
  rows.forEach(function (row) {
    var keys = validGroups.map(function (_ref) {
      var columnName = _ref.columnName;
      var column = columnsByName[columnName];
      var value = column.getCellValue ? column.getCellValue(row, columnName) : row[columnName];

      var _getGroupingFunction = getGroupingFunction(column)(value),
          key = _getGroupingFunction.key;

      return key;
    });
    keys.forEach(function (key, keyIndex) {
      var compoundKey = createCompoundKey(keys, keyIndex);
      groupKeys[compoundKey] = compoundKey;
    });
  });
  return values(groupKeys);
}
var GroupKeys =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(GroupKeys, _React$PureComponent);

  function GroupKeys() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;

    _this.expandAll = function (props) {
      props.onExpandAll(getGroupKeys(props.allRows.detailRows, props.grouping, props.tableColumns.map(function (tableColumn) {
        return tableColumn.column;
      })));
    };

    return _this;
  }

  var _proto = GroupKeys.prototype;

  _proto.render = function render() {
    return createElement(Plugin, null, createElement(Action, {
      name: "groupKeys",
      action: this.expandAll
    }));
  };

  return GroupKeys;
}(PureComponent);
var createCompoundKey = function createCompoundKey(keys, index) {
  var key = "";

  for (var i = 0; i <= index; i++) {
    if (i > 0) {
      key += "|";
    }

    key += keys[i];
  }

  return key;
};

var DataColumnType$1;

(function (DataColumnType) {
  DataColumnType[DataColumnType["ShortText"] = 0] = "ShortText";
  DataColumnType[DataColumnType["LongText"] = 1] = "LongText";
  DataColumnType[DataColumnType["Date"] = 2] = "Date";
  DataColumnType[DataColumnType["List"] = 3] = "List";
  DataColumnType[DataColumnType["States"] = 4] = "States";
  DataColumnType[DataColumnType["Subform"] = 5] = "Subform";
  DataColumnType[DataColumnType["Boolean"] = 6] = "Boolean";
  DataColumnType[DataColumnType["Number"] = 7] = "Number";
  DataColumnType[DataColumnType["Currency"] = 8] = "Currency";
  DataColumnType[DataColumnType["DateTime"] = 9] = "DateTime";
  DataColumnType[DataColumnType["Estimates"] = 10] = "Estimates";
  DataColumnType[DataColumnType["BidResults"] = 11] = "BidResults";
  DataColumnType[DataColumnType["Links"] = 12] = "Links";
  DataColumnType[DataColumnType["PhoneNumber"] = 13] = "PhoneNumber";
  DataColumnType[DataColumnType["CheckList"] = 14] = "CheckList";
})(DataColumnType$1 || (DataColumnType$1 = {}));

// @ts-ignore

var returnColumnInfo = function returnColumnInfo(columns) {
  var cols = columns.map(function (col) {
    if (col.props.tableColumn.column != null) {
      return {
        name: col.props.tableColumn.column.name,
        type: col.props.tableColumn.column.type,
        getCellValue: col.props.tableColumn.column.getCellValue ? col.props.tableColumn.column.getCellValue : function (row) {
          return row[col.props.tableColumn.column.name];
        }
      };
    }

    return null;
  }).filter(function (o) {
    return o !== null;
  });
  return cols;
};

var totalColumnValues = function totalColumnValues(colAccumulator, newValue, columnInfo) {
  return columnInfo.map(function (col) {
    var groupVal;

    if (colAccumulator.length > 0) {
      groupVal = colAccumulator.find(function (group) {
        return group.hasOwnProperty(col.name);
      });
    }

    if (col.type === DataColumnType$1.Number || col.type === DataColumnType$1.Currency) {
      var _ref;

      var newCellTotal = col.getCellValue(newValue);
      var valTotal = (groupVal && groupVal[col.name] ? groupVal[col.name] : 0) + (newCellTotal ? newCellTotal : 0);
      return _ref = {}, _ref[col.name] = valTotal, _ref.type = col.type, _ref;
    } else {
      var _ref2;

      return _ref2 = {}, _ref2[col.name] = null, _ref2.type = col.type, _ref2;
    }
  });
}; //filter to only rows in the group, grab the column names, reduce each into totals


var totalAndReduceColumn = function totalAndReduceColumn(getters, params, grouping) {
  var response = getters.allRows.detailRows.filter(function (row) {
    var matchesGroupKeys = true;
    var rowGroupKeysArray = params.tableRow.row.compoundKey.split("|"); //Handle multiple filters

    rowGroupKeysArray.forEach(function (tableRowGroupKey, index) {
      var allRowsGroupKeys = getGroupKeys([row], grouping, getters.tableColumns.map(function (tableColumn) {
        return tableColumn.column;
      })).slice(-1)[0].split("|");
      if (tableRowGroupKey !== allRowsGroupKeys[index]) matchesGroupKeys = false;
    });
    return matchesGroupKeys;
  }).reduce(function (groupRowAcc, newRow) {
    var columnInfo = returnColumnInfo(params.children); //for each column, attempt to sum up

    var totals = totalColumnValues(groupRowAcc, newRow, columnInfo);
    return totals;
  }, {});
  return response.length > 0 ? response : [];
};

var GroupTotals = function GroupTotals() {
  var _useTableContext = useTableContext(),
      grouping = _useTableContext.grouping.grouping;

  return React__default.createElement(Plugin, {
    name: "GroupTotals"
  }, React__default.createElement(Template, {
    name: "tableRow",
    predicate: function predicate(_ref3) {
      var tableRow = _ref3.tableRow;
      return isGroupTableRow(tableRow);
    }
  }, function (params) {
    return React__default.createElement(TemplateConnector, null, function (getters) {
      var updatedParams = produce(params, function (draft) {
        draft.grouping = getters.grouping;
        draft.tableRow.row.totaledColumnData = totalAndReduceColumn(getters, params, grouping);
      });
      return React__default.createElement(TemplatePlaceholder, {
        params: updatedParams
      });
    });
  }));
};

var SearchState = function SearchState(props) {
  var _useTableContext = useTableContext(),
      _useTableContext$sear = _useTableContext.search,
      searchValue = _useTableContext$sear.searchValue,
      setSearchValue = _useTableContext$sear.setSearchValue;

  return useMemo(function () {
    // console.log("search");
    return createElement(SearchState$1, Object.assign({
      value: searchValue,
      onValueChange: setSearchValue
    }, props));
  }, [searchValue, setSearchValue, props]);
};

var SelectionState = function SelectionState(props) {
  var _useTableContext = useTableContext(),
      _useTableContext$sele = _useTableContext.selection,
      selection = _useTableContext$sele.selection,
      setSelection = _useTableContext$sele.setSelection;

  return useMemo(function () {
    console.log("selection");
    return createElement(SelectionState$1, Object.assign({
      selection: selection,
      onSelectionChange: setSelection
    }, props));
  }, [selection, setSelection, props]);
};

var nullUndefinedCompare = function nullUndefinedCompare(a, b) {
  var aIsEmpty = a === null || a === undefined;
  var bIsEmpty = b === null || b === undefined;

  if (aIsEmpty && bIsEmpty) {
    return {
      isNullOrUndefined: true,
      sortIndex: 0
    };
  }

  if (aIsEmpty) {
    return {
      isNullOrUndefined: true,
      sortIndex: -1
    };
  }

  if (bIsEmpty) {
    return {
      isNullOrUndefined: true,
      sortIndex: 1
    };
  }

  return {
    isNullOrUndefined: false,
    sortIndex: 0
  };
};
var dateValidityCompare = function dateValidityCompare(a, b) {
  if (a.isValid() && !b.isValid()) {
    return 1;
  } else if (!a.isValid() && b.isValid()) {
    return -1;
  }

  return 0;
};
var dateCompare = function dateCompare(a, b) {
  if (a === void 0) {
    a = null;
  }

  if (b === void 0) {
    b = null;
  }

  var nullUndefinedCheck = nullUndefinedCompare(a, b);

  if (nullUndefinedCheck.isNullOrUndefined) {
    return nullUndefinedCheck.sortIndex;
  }

  var dateA = moment(a);
  var dateB = moment(b);
  var validityCompare = dateValidityCompare(dateA, dateB);

  if (validityCompare !== 0) {
    return validityCompare;
  }

  dateA.startOf("day");
  dateB.startOf("day");

  if (dateA.isBefore(dateB)) {
    return -1;
  } else if (dateB.isBefore(dateA)) {
    return 1;
  }

  return 0;
};
var dateTimeCompare = function dateTimeCompare(a, b) {
  if (a === void 0) {
    a = null;
  }

  if (b === void 0) {
    b = null;
  }

  var nullUndefinedCheck = nullUndefinedCompare(a, b);

  if (nullUndefinedCheck.isNullOrUndefined) {
    return nullUndefinedCheck.sortIndex;
  }

  var dateA = moment(a);
  var dateB = moment(b);
  var validityCompare = dateValidityCompare(dateA, dateB);

  if (validityCompare !== 0) {
    return validityCompare;
  }

  dateA.startOf("minute");
  dateB.startOf("minute");

  if (dateA.isBefore(dateB)) {
    return -1;
  } else if (dateB.isBefore(dateA)) {
    return 1;
  }

  return 0;
};
var stringCompare = function stringCompare(a, b) {
  if (a === void 0) {
    a = null;
  }

  if (b === void 0) {
    b = null;
  }

  var valueA = a === "" ? undefined : a;
  var valueB = b === "" ? undefined : b;
  var nullUndefinedCheck = nullUndefinedCompare(valueA, valueB);

  if (nullUndefinedCheck.isNullOrUndefined) {
    return nullUndefinedCheck.sortIndex;
  }

  return a.localeCompare(b, undefined, {
    sensitivity: "base"
  });
};
var linkToString$1 = function linkToString(value) {
  var retString = "";

  if (value) {
    value.forEach(function (link, index) {
      retString += index > 0 ? ", " : "";
      retString += link.description || link.url;
    });
  }

  return retString === "" ? undefined : retString;
};
var checklistToNumber = function checklistToNumber(value) {
  if (!value) {
    return undefined;
  }

  var allCheckedCount = 0;
  value.forEach(function (list) {
    allCheckedCount += list.checked ? 1 : 0;
  });
  return Math.abs(allCheckedCount / value.length) * 100;
};
var linkCompare = function linkCompare(a, b) {
  if (a === void 0) {
    a = null;
  }

  if (b === void 0) {
    b = null;
  }

  var linkAString = linkToString$1(a);
  var linkBString = linkToString$1(b);
  var nullUndefinedCheck = nullUndefinedCompare(linkAString, linkBString);

  if (nullUndefinedCheck.isNullOrUndefined) {
    return nullUndefinedCheck.sortIndex;
  }

  return linkAString.localeCompare(linkBString, undefined, {
    sensitivity: "base"
  });
};
var listCompare = function listCompare(config, a, b) {
  if (config === void 0) {
    config = {
      listValues: []
    };
  }

  if (!config.customSort) {
    var _ref3, _config$fallbackSortF, _config;

    if (config.showLabelValueInTable) {
      var _config$listValues$fi, _config$listValues$fi2, _ref, _config$listValues$fi3, _ref2, _config$listValues$fi4;

      var labelA = (_config$listValues$fi = config.listValues.find(function (opt) {
        return opt.value === a;
      })) === null || _config$listValues$fi === void 0 ? void 0 : _config$listValues$fi.display;
      var labelB = (_config$listValues$fi2 = config.listValues.find(function (opt) {
        return opt.value === b;
      })) === null || _config$listValues$fi2 === void 0 ? void 0 : _config$listValues$fi2.display;

      if (config.fallbackSortFunction && (!labelA || !labelB)) {
        return config.fallbackSortFunction(labelA, labelB);
      }

      return stringCompare((_ref = (_config$listValues$fi3 = config.listValues.find(function (opt) {
        return opt.value === a;
      })) === null || _config$listValues$fi3 === void 0 ? void 0 : _config$listValues$fi3.display) !== null && _ref !== void 0 ? _ref : a, (_ref2 = (_config$listValues$fi4 = config.listValues.find(function (opt) {
        return opt.value === b;
      })) === null || _config$listValues$fi4 === void 0 ? void 0 : _config$listValues$fi4.display) !== null && _ref2 !== void 0 ? _ref2 : b);
    }

    return (_ref3 = (_config$fallbackSortF = (_config = config).fallbackSortFunction) === null || _config$fallbackSortF === void 0 ? void 0 : _config$fallbackSortF.call(_config, a, b)) !== null && _ref3 !== void 0 ? _ref3 : stringCompare(a, b);
  }

  if (a === "") a = undefined;
  if (b === "") b = undefined;
  var nullUndefinedCheck = nullUndefinedCompare(a, b);

  if (nullUndefinedCheck.isNullOrUndefined) {
    return nullUndefinedCheck.sortIndex;
  }

  var indexA = config.listValues.findIndex(function (opt) {
    return opt.value === a;
  });
  var indexB = config.listValues.findIndex(function (opt) {
    return opt.value === b;
  });

  if (indexA === -1 && indexB === -1) {
    var _ref4, _config$fallbackSortF2, _config2;

    return (_ref4 = (_config$fallbackSortF2 = (_config2 = config).fallbackSortFunction) === null || _config$fallbackSortF2 === void 0 ? void 0 : _config$fallbackSortF2.call(_config2, a, b)) !== null && _ref4 !== void 0 ? _ref4 : stringCompare(a, b);
  }

  if (indexA === indexB) {
    return 0;
  }

  if (indexA === -1) {
    indexA = config.listValues.length;
  }

  if (indexB === -1) {
    indexB = config.listValues.length;
  }

  return indexA < indexB ? -1 : 1;
};
var checkListCompare = function checkListCompare(a, b) {
  if (a === void 0) {
    a = null;
  }

  if (b === void 0) {
    b = null;
  }

  var checkListANumber = checklistToNumber(a);
  var checkListBNumber = checklistToNumber(b);
  return numberCompare(checkListANumber, checkListBNumber);
};
var booleanCompare = function booleanCompare(a, b) {
  if (a === void 0) {
    a = null;
  }

  if (b === void 0) {
    b = null;
  }

  var booleanA = typeof a === "boolean" && a;
  var booleanB = typeof b === "boolean" && b;

  if (!booleanA && booleanB) {
    return -1;
  }

  if (booleanA && !booleanB) {
    return 1;
  }

  return 0;
};
var numberCompare = function numberCompare(a, b) {
  if (a === void 0) {
    a = null;
  }

  if (b === void 0) {
    b = null;
  }

  var nullUndefinedCheck = nullUndefinedCompare(a, b);

  if (nullUndefinedCheck.isNullOrUndefined) {
    return nullUndefinedCheck.sortIndex;
  }

  var numberA = numeral(a).value();
  var numberB = numeral(b).value();

  if (numberA === numberB) {
    return 0;
  }

  if (isNaN(numberA) || isNaN(numberB)) {
    return !isNaN(numberA) ? -1 : 1;
  }

  return numberA < numberB ? -1 : 1;
};
var defaultCustomCompare = function defaultCustomCompare(a, b) {
  return 0;
};

var IntegratedSorting = function IntegratedSorting() {
  var _useTableContext = useTableContext(),
      columns = _useTableContext.columns;

  return useMemo(function () {
    // console.log("sorting extensions");
    var extensions = generateSortingExtensions(columns);
    return createElement(IntegratedSorting$1, {
      columnExtensions: extensions
    });
  }, [columns]);
};
function generateSortingExtensions(columns) {
  return columns.map(function (column) {
    return {
      columnName: column.name,
      compare: getComparer(column)
    };
  });
}

function getComparer(column) {
  if (column.type === DataColumnType.Number || column.type === DataColumnType.Currency) {
    return numberCompare;
  }

  if (column.type === DataColumnType.Date) {
    return dateCompare;
  }

  if (column.type === DataColumnType.DateTime) {
    return dateTimeCompare;
  }

  if (column.type === DataColumnType.Boolean) {
    return booleanCompare;
  }

  if (column.type === DataColumnType.Links) {
    return linkCompare;
  }

  if (column.type === DataColumnType.CheckList) {
    return checkListCompare;
  }

  if (column.type === DataColumnType.List) {
    return listCompare.bind(null, column.config);
  }

  if (column.type === DataColumnType.Custom) {
    if (column.config) {
      var _column$config;

      return (_column$config = column.config) === null || _column$config === void 0 ? void 0 : _column$config.sortingFunction;
    }

    return defaultCustomCompare;
  }

  return stringCompare;
}

var SortingState = function SortingState(_ref) {
  var passedSorting = _ref.sorting,
      other = _objectWithoutPropertiesLoose(_ref, ["sorting"]);

  var _useTableContext = useTableContext(),
      _useTableContext$sort = _useTableContext.sorting,
      sorting = _useTableContext$sort.sorting,
      setSorting = _useTableContext$sort.setSorting,
      extendedGroups = _useTableContext.extendedGroups;

  return useMemo(function () {
    // console.log("sorting");
    var groupedSorting = createGroupedSorting(extendedGroups, passedSorting !== null && passedSorting !== void 0 ? passedSorting : sorting);
    return createElement(SortingState$1, Object.assign({
      sorting: groupedSorting,
      onSortingChange: setSorting
    }, other));
  }, [extendedGroups, passedSorting, sorting, setSorting, other]);
};

var IntegratedSummary =
/*#__PURE__*/
memo(function (props) {
  return createElement(IntegratedSummary$1, Object.assign({
    calculator: customCalculator
  }, props));
});
var SummaryCalculator = IntegratedSummary;
var customCalculator = function customCalculator(type, rows, getValue) {
  if (type === SummaryType.Sum) {
    if (!rows.length) {
      return null;
    }

    var total = rows.reduce(function (sum, row) {
      var value = getValue(row) || 0;
      return sum + value;
    }, 0);
    return total;
  }

  if (type === SummaryType.Avg) {
    if (!rows.length) {
      return null;
    }

    var nonNullRows = rows.filter(function (row) {
      var value = getValue(row);
      return value !== undefined && value !== null;
    });
    return nonNullRows.reduce(function (sum, row) {
      return sum + getValue(row);
    }, 0) / nonNullRows.length;
  }

  return IntegratedSummary$1.defaultCalculator(type, rows, getValue);
};

/**
 * Fixes the double counting bug in DevExpress < 2.6.2
 *
 * @remarks
 * ONLY NEEDED FOR 2.6.1 and below
 */

var GroupSummaryFix = function GroupSummaryFix(_ref) {
  var calculator = _ref.calculator;

  var _useTableContext = useTableContext(),
      columnLookup = _useTableContext.columnLookup,
      extendedGroups = _useTableContext.extendedGroups;

  return useMemo(function () {
    var filteredGroups = extendedGroups.filter(function (g) {
      var _g$originalColumnName;

      return ((_g$originalColumnName = g.originalColumnName) !== null && _g$originalColumnName !== void 0 ? _g$originalColumnName : g.columnName) in columnLookup;
    });

    var groupSummaryValuesComputed = function groupSummaryValuesComputed(_ref2) {
      var allRows = _ref2.allRows,
          groupSummaryItems = _ref2.groupSummaryItems;
      var summaries = createGroupSummaries(columnLookup, groupSummaryItems.map(function (c) {
        return columnLookup[c.columnName];
      }), filteredGroups, allRows.detailRows, calculator);
      return summaries;
    };

    return React__default.createElement(Plugin, null, React__default.createElement(Getter, {
      name: "groupSummaryValues",
      computed: groupSummaryValuesComputed
    }));
  }, [calculator, columnLookup, extendedGroups]);
};

function createGroupSummaries(columnLookup, columns, grouping, rows, calculator) {
  var summaries = {};

  var _loop = function _loop(index) {
    var groups = grouping.slice(0, index + 1);
    var groupLookup = getRowsForLevel(columnLookup, columns, groups, rows);
    Object.keys(groupLookup).forEach(function (k) {
      summaries[k] = columns.map(function (c) {
        return groupLookup[k].reduce(function (prev, curr) {
          var _ref3, _c$getCellValue;

          var currentValue = (_ref3 = (_c$getCellValue = c.getCellValue) === null || _c$getCellValue === void 0 ? void 0 : _c$getCellValue.call(c, curr, c.name)) !== null && _ref3 !== void 0 ? _ref3 : curr[c.name];
          return calculator(currentValue) + prev;
        }, 0);
      });
    });
  };

  for (var index = 0; index < grouping.length; index++) {
    _loop(index);
  }

  return summaries;
}

function getRowsForLevel(columnLookup, columns, grouping, rows) {
  var groupedRows = groupBy(rows, function (row) {
    return grouping.reduce(function (prev, curr, index) {
      var _ref4, _currentColumn$getCel;

      var currentColumn = columnLookup[curr.columnName];
      var currentValue = (_ref4 = currentColumn === null || currentColumn === void 0 ? void 0 : (_currentColumn$getCel = currentColumn.getCellValue) === null || _currentColumn$getCel === void 0 ? void 0 : _currentColumn$getCel.call(currentColumn, row, currentColumn.name)) !== null && _ref4 !== void 0 ? _ref4 : row[curr.columnName];
      var groupValue = getGroupingFunction(currentColumn)(currentValue);
      if (index === 0) return "" + groupValue.key;
      return prev + "|" + groupValue.key;
    }, "");
  });
  return groupedRows;
}

var SummaryState = function SummaryState(props) {
  var _useTableContext = useTableContext(),
      columns = _useTableContext.columns,
      extendedGroups = _useTableContext.extendedGroups,
      summaryItems = _useTableContext.summary.summaryItems;

  return useMemo(function () {
    var allSummaryItems = createDefaultSummaryItems(columns, summaryItems, extendedGroups);
    return createElement(SummaryState$1, Object.assign({
      totalItems: allSummaryItems,
      groupItems: allSummaryItems.map(function (s) {
        return _extends({}, s, {
          showInGroupFooter: false,
          alignByColumn: true
        });
      })
    }, props));
  }, [props, columns, summaryItems, extendedGroups]);
};
function createDefaultSummaryItems(columns, currentSummaryItems, grouping) {
  var newItems = [].concat(currentSummaryItems);
  var numericColumns = columns.filter(function (c) {
    return c.type === DataColumnType.Number || c.type === DataColumnType.Currency;
  }).map(function (column) {
    return {
      columnName: column.name,
      type: SummaryType.Sum
    };
  });
  numericColumns.forEach(function (column) {
    if (!newItems.find(function (i) {
      return i.columnName === column.columnName;
    })) {
      newItems.push(column);
    }
  });
  return newItems.filter(function (item) {
    return !grouping.find(function (g) {
      return g.columnName === item.columnName;
    });
  }); // we have to filter grouped columns because if we are grouped on a numeric column it will cause the group totals to be off by one
}

var TableSummaryRow = function TableSummaryRow(_ref) {
  var _extends2;

  var messages = _ref.messages,
      other = _objectWithoutPropertiesLoose(_ref, ["messages"]);

  var mergedMessages = _extends((_extends2 = {
    filteredSum: "Sum"
  }, _extends2[SummaryType.Sum] = "Sum", _extends2[SummaryType.Avg] = "Avg", _extends2[SummaryType.Count] = "Count", _extends2), messages);

  return createElement(TableSummaryRow$1, Object.assign({
    messages: mergedMessages,
    itemComponent: CellItemComponent,
    formatlessSummaryTypes: ["filteredSum"]
  }, other));
};

var CellItemComponent = function CellItemComponent(props) {
  if (props.type === "filteredSum") {
    return createElement("div", null, createElement("strong", null, numeral(props.value).format("$0,0.00")));
  }

  var DefaultItem = TableSummaryRow$1.Item;
  return createElement(DefaultItem, Object.assign({}, props));
};

var TableContainer = function TableContainer(_ref) {
  var columns = _ref.columns,
      sections = _ref.sections,
      templateName = _ref.templateName,
      overrides = _ref.overrides,
      defaults = _ref.defaults,
      children = _ref.children;
  return createElement(useTableContext.Provider, {
    templateName: templateName,
    sections: sections,
    columns: columns,
    key: templateName,
    overrides: overrides,
    defaults: defaults
  }, children);
};

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 2px 5px !important;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  & .modal-content {\n    border: none;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 16px;\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteralLoose(["\n  break-inside: avoid;\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding: 0 16px;\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n  columns: 2 200px;\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  max-height: 70vh;\n  overflow-y: auto;\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var ColumnChooserModal = function ColumnChooserModal(_ref) {
  var messages = _ref.messages;

  var _useTableContext = useTableContext(),
      columnLookup = _useTableContext.columnLookup,
      columns = _useTableContext.columns,
      sections = _useTableContext.sections,
      _useTableContext$visi = _useTableContext.visibility,
      hiddenColumns = _useTableContext$visi.hiddenColumns,
      setHiddenColumns = _useTableContext$visi.setHiddenColumns,
      _useTableContext$colu = _useTableContext.columnSelect,
      showModal = _useTableContext$colu.showModal,
      setShowModal = _useTableContext$colu.setShowModal;

  var changeHiddenColumns = useCallback(function (column, show) {
    var newHiddenColumns = [].concat(hiddenColumns);
    column.hidingEnabled && !show && newHiddenColumns.indexOf(column.name) === -1 ? newHiddenColumns.push(column.name) : newHiddenColumns = newHiddenColumns.filter(function (columnName) {
      return columnName !== column.name;
    });
    setHiddenColumns(newHiddenColumns);
  }, [hiddenColumns, setHiddenColumns]);
  var showAllColumns = useCallback(function () {
    setHiddenColumns([]);
  }, [setHiddenColumns]);
  var hideAllColumns = useCallback(function () {
    setHiddenColumns(columns.filter(function (column) {
      return column.hidingEnabled;
    }).map(function (column) {
      return column.name;
    }));
  }, [setHiddenColumns, columns]);
  return useMemo(function () {
    var _ref2, _ref3, _ref4, _ref5;

    // console.log("column chooser modal");
    var hiddenColumnLookup = keyBy(hiddenColumns);
    return createElement(StyledModal, {
      show: showModal,
      onHide: function onHide() {
        return setShowModal(!showModal);
      }
    }, createElement(Modal.Header, {
      closeButton: true
    }, createElement(Modal.Title, null, (_ref2 = messages === null || messages === void 0 ? void 0 : messages.title) !== null && _ref2 !== void 0 ? _ref2 : "Edit Columns")), createElement(ScrollableModalBody, {
      "data-testid": "columnchooser-modal"
    }, createElement(ModalColumns, null, sections.length === 0 && createElement(SectionColumnContainer, null, createElement(ColumnList, null, columns.map(function (column) {
      return createElement(ColumnCheckbox, {
        column: column,
        hiddenColumnLookup: hiddenColumnLookup,
        changeHiddenColumns: changeHiddenColumns
      });
    }))), sections.map(function (section) {
      return createElement(SectionColumnContainer, {
        key: section.name
      }, createElement(ColumnList, null, createElement(SectionLabel, null, createElement(TextOverflow, null, section.name)), section.fields.map(function (fieldId) {
        var column = columnLookup[fieldId];
        return column && createElement(ColumnCheckbox, {
          key: column.name,
          column: column,
          hiddenColumnLookup: hiddenColumnLookup,
          changeHiddenColumns: changeHiddenColumns
        });
      })));
    }))), createElement(Modal.Footer, null, createElement(Fragment, null, createElement("div", {
      style: {
        "float": "left"
      }
    }, createElement(Button, {
      hcssStyle: "ThemeInverted",
      onClick: showAllColumns
    }, (_ref3 = messages === null || messages === void 0 ? void 0 : messages.showAll) !== null && _ref3 !== void 0 ? _ref3 : "Show All"), createElement(Button, {
      hcssStyle: "ThemeInverted",
      onClick: hideAllColumns
    }, (_ref4 = messages === null || messages === void 0 ? void 0 : messages.hideAll) !== null && _ref4 !== void 0 ? _ref4 : "Hide All")), createElement("div", {
      style: {
        "float": "right"
      }
    }, createElement(Button, {
      onClick: function onClick() {
        return setShowModal(false);
      }
    }, (_ref5 = messages === null || messages === void 0 ? void 0 : messages.close) !== null && _ref5 !== void 0 ? _ref5 : "Close")))));
  }, [hiddenColumns, showModal, messages, sections, columns, showAllColumns, hideAllColumns, setShowModal, changeHiddenColumns, columnLookup]);
};

var ColumnCheckbox = function ColumnCheckbox(_ref6) {
  var column = _ref6.column,
      hiddenColumnLookup = _ref6.hiddenColumnLookup,
      changeHiddenColumns = _ref6.changeHiddenColumns;
  var isVisible = !(column.name in hiddenColumnLookup);
  return createElement(Flex, {
    alignItems: "center"
  }, createElement(Checkbox, {
    disabled: !column.hidingEnabled,
    key: column.name,
    checked: isVisible,
    onChange: function onChange() {
      changeHiddenColumns(column, !isVisible);
    }
  }), createElement(TextOverflow, {
    style: {
      cursor: "pointer"
    },
    onClick: function onClick() {
      changeHiddenColumns(column, !isVisible);
    }
  }, column.title), createElement(NumericOptionsToggle, {
    column: column
  }));
};

var NumericOptionsToggle = function NumericOptionsToggle(_ref7) {
  var _ref8, _summaryItems$find;

  var column = _ref7.column;

  var _useTableContext2 = useTableContext(),
      _useTableContext2$sum = _useTableContext2.summary,
      setSummaryItems = _useTableContext2$sum.setSummaryItems,
      summaryItems = _useTableContext2$sum.summaryItems,
      showOptionToggle = _useTableContext2$sum.showOptionToggle;

  if (!showOptionToggle(column)) return null;
  var selected = (_ref8 = (_summaryItems$find = summaryItems.find(function (summ) {
    return column.name === summ.columnName;
  })) === null || _summaryItems$find === void 0 ? void 0 : _summaryItems$find.type) !== null && _ref8 !== void 0 ? _ref8 : SummaryType.Sum;
  return createElement(ToggleButtonGroup, {
    type: "radio",
    bsSize: "sm",
    value: selected,
    name: "options",
    onChange: function onChange(e) {
      setSummaryItems(e, column);
    }
  }, createElement(StyledButton, {
    type: "radio",
    value: SummaryType.Sum
  }, "Sum"), createElement(StyledButton, {
    type: "radio",
    value: SummaryType.Avg
  }, "Avg"));
};

var ScrollableModalBody =
/*#__PURE__*/
styled(Modal.Body)(
/*#__PURE__*/
_templateObject$5());
var ModalColumns =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject2$4());
var ColumnList =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject3$2());
var SectionColumnContainer =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject4$2());
var SectionLabel =
/*#__PURE__*/
styled.label(
/*#__PURE__*/
_templateObject5$1());
var StyledModal =
/*#__PURE__*/
styled(Modal)(
/*#__PURE__*/
_templateObject6());
var StyledButton =
/*#__PURE__*/
styled(ToggleButton)(
/*#__PURE__*/
_templateObject7());
var TextOverflow =
/*#__PURE__*/
styled(Box)(
/*#__PURE__*/
_templateObject8());

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n  order: ", ";\n  display: flex;\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var ButtonContainer =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$6(), function (props) {
  return props.order;
});

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n  color: #333;\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var ToolbarIconButton =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(ToolbarIconButton, _React$PureComponent);

  function ToolbarIconButton() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = ToolbarIconButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        iconName = _this$props.iconName,
        onClick = _this$props.onClick,
        className = _this$props.className,
        title = _this$props.title,
        margin = _this$props.margin,
        dropdown = _this$props.dropdown,
        options = _this$props.options;

    if (dropdown) {
      return createElement(Dropdown, {
        id: "tableoptions-" + iconName,
        pullRight: true
      }, createElement(Dropdown.Toggle, {
        bsStyle: "link",
        noCaret: true
      }, createElement(StyledIcon, {
        name: iconName,
        margin: margin
      })), createElement(Dropdown.Menu, null, options.map(function (option, index) {
        return createElement(MenuItem$1, {
          key: option.name,
          eventKey: index,
          onClick: option.onClick
        }, option.name);
      })));
    }

    return createElement(Button, {
      className: className,
      title: title,
      bsStyle: "link",
      onClick: onClick
    }, createElement(StyledIcon, {
      name: iconName,
      margin: margin
    }));
  };

  return ToolbarIconButton;
}(PureComponent);
var StyledIcon =
/*#__PURE__*/
styled(Icon)(
/*#__PURE__*/
_templateObject$7());

var ColumnVisibilityButton =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(ColumnVisibilityButton, _React$PureComponent);

  function ColumnVisibilityButton() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = ColumnVisibilityButton.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.buttonRef(this);
  };

  _proto.render = function render() {
    return createElement(ButtonContainer, {
      order: 3
    }, createElement(ToolbarIconButton, {
      onClick: this.props.onToggle,
      iconName: "columns"
    }));
  };

  return ColumnVisibilityButton;
}(PureComponent);

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n  color: #333;\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var OtherOptions = function OtherOptions(_ref) {
  var onExpandAll = _ref.onExpandAll,
      onCollapseAll = _ref.onCollapseAll,
      messages = _ref.messages,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
  var _options$showCsvExpor = options.showCsvExport,
      showCsvExport = _options$showCsvExpor === void 0 ? true : _options$showCsvExpor,
      _options$showPdfExpor = options.showPdfExport,
      showPdfExport = _options$showPdfExpor === void 0 ? true : _options$showPdfExpor,
      _options$showColumnVi = options.showColumnVisibility,
      showColumnVisibility = _options$showColumnVi === void 0 ? true : _options$showColumnVi,
      _options$showExpandCo = options.showExpandCollapse,
      showExpandCollapse = _options$showExpandCo === void 0 ? true : _options$showExpandCo;

  var _useTableContext = useTableContext(),
      grouping = _useTableContext.grouping.grouping,
      setShowModal = _useTableContext.columnSelect.setShowModal;

  return createElement(Plugin, {
    key: "csv"
  }, createElement(Template, {
    name: "toolbarContent"
  }, createElement(TemplatePlaceholder, null), createElement(TemplateConnector, null, function (getters, actions) {
    var _ref2, _ref3, _ref4, _ref5, _ref6;

    return createElement(ButtonContainer, {
      order: 4
    }, createElement("div", {
      "data-testid": "projectsmenu-options"
    }, createElement(Dropdown, {
      id: "other-options",
      pullRight: true
    }, createElement(Dropdown.Toggle, {
      bsStyle: "link",
      noCaret: true
    }, createElement(StyledIcon$1, {
      name: "ellipsis-v"
    })), createElement(Dropdown.Menu, null, showCsvExport && createElement(MenuItem$1, {
      key: "exportcsv",
      eventKey: 0,
      onClick: function onClick() {
        return actions.exportCSV({
          tableColumns: getters.tableColumns,
          exportRows: getters.allRows.detailRows,
          getCellValue: getters.getCellValue
        });
      }
    }, (_ref2 = messages === null || messages === void 0 ? void 0 : messages.exportCsv) !== null && _ref2 !== void 0 ? _ref2 : "Export to CSV"), showPdfExport && createElement(MenuItem$1, {
      key: "exportpdf",
      eventKey: 1,
      onClick: function onClick() {
        return actions.exportPDF({
          tableColumns: getters.tableColumns,
          exportRows: getters.allRows.detailRows,
          getCellValue: getters.getCellValue
        });
      }
    }, (_ref3 = messages === null || messages === void 0 ? void 0 : messages.exportPdf) !== null && _ref3 !== void 0 ? _ref3 : "Export to PDF"), showColumnVisibility && createElement(MenuItem$1, {
      key: "selectColumns",
      eventKey: 2,
      onClick: function onClick() {
        return setShowModal(true);
      }
    }, (_ref4 = messages === null || messages === void 0 ? void 0 : messages.showHideColumns) !== null && _ref4 !== void 0 ? _ref4 : "Edit Columns"), showExpandCollapse && grouping.length > 0 && createElement(MenuItem$1, {
      key: "expand",
      eventKey: 4,
      onClick: function onClick() {
        return actions.groupKeys({
          allRows: getters.allRows,
          grouping: getters.grouping,
          onExpandAll: onExpandAll,
          tableColumns: getters.tableColumns
        });
      }
    }, (_ref5 = messages === null || messages === void 0 ? void 0 : messages.expandAll) !== null && _ref5 !== void 0 ? _ref5 : "Expand All"), showExpandCollapse && grouping.length > 0 && createElement(MenuItem$1, {
      key: "collapse",
      eventKey: 5,
      onClick: onCollapseAll
    }, (_ref6 = messages === null || messages === void 0 ? void 0 : messages.collapseAll) !== null && _ref6 !== void 0 ? _ref6 : "Collapse All")))));
  })));
};
var StyledIcon$1 =
/*#__PURE__*/
styled(Icon)(
/*#__PURE__*/
_templateObject$8());

var OtherOptionsButton = function OtherOptionsButton(props) {
  var _useTableContext = useTableContext(),
      setExpandedGroups = _useTableContext.grouping.setExpandedGroups;

  return useMemo(function () {
    // console.log("other options");
    return createElement(OtherOptions, Object.assign({
      onCollapseAll: function onCollapseAll() {
        return setExpandedGroups([]);
      },
      onExpandAll: function onExpandAll(groups) {
        return setExpandedGroups(groups);
      }
    }, props));
  }, [setExpandedGroups, props]);
};

var VirtualTable = function VirtualTable(props) {
  var _useTableContext = useTableContext(),
      columns = _useTableContext.columns;

  return useMemo(function () {
    return createElement(VirtualTable$1, Object.assign({
      height: "auto",
      estimatedRowHeight: 60,
      columnExtensions: generateTableColumnExtensions(columns),
      stubCellComponent: StubCellComponent
    }, props));
  }, [columns, props]);
};

var StubCellComponent = function StubCellComponent(_ref) {
  var children = _ref.children,
      other = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return createElement(VirtualTable$1.StubCell, Object.assign({}, other, {
    colSpan: other.tableColumn.key !== "Symbol(flex)" ? 1 : 2
  }), children);
};

var TableGroupRow = function TableGroupRow(props) {
  return React__default.createElement(TableGroupRow$1, Object.assign({
    cellComponent: GroupCell,
    indentCellComponent: StubCell
  }, props));
};
var StubCell = function StubCell(props) {
  return React__default.createElement(VirtualTable$1.Cell, Object.assign({}, props, {
    style: _extends({}, props.style, {
      backgroundColor: "#FFF"
    })
  }));
};
var SummaryCell = function SummaryCell(props) {
  var _ref, _props$predicate;

  if ((_ref = (_props$predicate = props.predicate) === null || _props$predicate === void 0 ? void 0 : _props$predicate.call(props, props.type)) !== null && _ref !== void 0 ? _ref : true) {
    var _ref2, _props$format;

    return React__default.createElement("div", null, React__default.createElement("strong", null, (_ref2 = (_props$format = props.format) === null || _props$format === void 0 ? void 0 : _props$format.call(props, props.value)) !== null && _ref2 !== void 0 ? _ref2 : props.value));
  }

  return React__default.createElement(TableGroupRow$1.SummaryItem, Object.assign({}, props));
};

function _templateObject2$5() {
  var data = _taggedTemplateLiteralLoose(["\n  top: 0px;\n  font-size: 9px;\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-right: 5px;\n  margin-bottom: 5px;\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var GroupingPanel = function GroupingPanel(props) {
  return React__default.createElement(GroupingPanel$1, Object.assign({}, props, {
    itemComponent: GroupingPanelItem
  }));
};
var GroupingPanelItem = function GroupingPanelItem(_ref) {
  var _column$config;

  var showSortingControls = _ref.showSortingControls,
      showGroupingControls = _ref.showGroupingControls,
      sortingDirection = _ref.sortingDirection,
      onSort = _ref.onSort,
      onGroup = _ref.onGroup,
      item = _ref.item,
      other = _objectWithoutPropertiesLoose(_ref, ["showSortingControls", "showGroupingControls", "sortingDirection", "onSort", "onGroup", "item"]);

  var column = item.column;
  return React__default.createElement(ButtonGroup, {
    className: "btn-group"
  }, React__default.createElement("span", {
    className: "btn btn-default",
    onClick: function onClick() {
      if (showSortingControls) {
        onSort({
          direction: sortingDirection !== "asc" ? "asc" : "desc"
        });
      }
    }
  }, item.column.title, showSortingControls && sortingDirection && React__default.createElement("span", null, "\xA0", React__default.createElement(ButtonIcon, {
    className: "glyphicon glyphicon-arrow-" + (sortingDirection === "asc" ? "up" : "down")
  }))), (column.type === DataColumnType.DateTime || column.type === DataColumnType.Date) && React__default.createElement(Dropdown, {
    id: "group-" + column.name
  }, React__default.createElement(Dropdown.Toggle, {
    noCaret: true
  }, React__default.createElement(ButtonIcon, {
    className: "glyphicon glyphicon-calendar"
  })), React__default.createElement(Dropdown.Menu, null, React__default.createElement(DateOptions, {
    column: column,
    activeItem: (_column$config = column.config) === null || _column$config === void 0 ? void 0 : _column$config.dateGrouping
  }))), showGroupingControls && React__default.createElement("span", {
    style: {
      fontSize: "14px"
    },
    className: "btn btn-default",
    onClick: function onClick() {
      return onGroup();
    }
  }, React__default.createElement(ButtonIcon, {
    className: "glyphicon glyphicon-remove"
  })));
};

var DateOptions = function DateOptions(_ref2) {
  var activeItem = _ref2.activeItem,
      column = _ref2.column,
      _ref2$keys = _ref2.keys,
      keys = _ref2$keys === void 0 ? ["year", "quarter", "month", "week", "day"] : _ref2$keys;

  var _useTableContext = useTableContext(),
      setGrouping = _useTableContext.grouping.setGrouping,
      extendedGroups = _useTableContext.extendedGroups;

  var updateDateType = function updateDateType(interval) {
    var existingGroupIndex = extendedGroups.findIndex(function (group) {
      return group.columnName === column.name;
    });

    var newGroup = _extends({}, extendedGroups[existingGroupIndex], {
      config: {
        dateGrouping: interval
      }
    });

    var newGroups = [].concat(extendedGroups);
    newGroups.splice(existingGroupIndex, 1, newGroup);
    setGrouping(newGroups);
  };

  return React__default.createElement(React__default.Fragment, null, keys.map(function (key) {
    return React__default.createElement(MenuItem$1, {
      key: key,
      active: key === activeItem,
      onClick: function onClick() {
        return updateDateType(key);
      }
    }, capitalize(key));
  }));
};

var ButtonGroup =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$9());
var ButtonIcon =
/*#__PURE__*/
styled.i(
/*#__PURE__*/
_templateObject2$5());

var Grid = function Grid(_ref) {
  var children = _ref.children,
      other = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var _useTableContext = useTableContext(),
      columns = _useTableContext.columns;

  return React__default.createElement(Grid$1, Object.assign({
    rootComponent: Root
  }, other, {
    columns: columns
  }), React__default.Children.map(children, function (child) {
    return child;
  }));
};

export { AllRows, BooleanEditor, BooleanFormatProvider, ButtonContainer, CellComponent, ColumnChooserModal, ColumnReordering, ColumnResizing, ColumnVisibility, ColumnVisibilityButton, CommandButton, CommandComponent, DataColumnType, DateContainer, DateFormatProvider, DateFormatter, DateTimeContainer, DropDownEditor, DropDownFormatProvider, DropDownFormatter, EditCellComponent, EditCellHeaderComponent, ExportRows, FilteringState, Grid, GroupCell, GroupKeys, GroupSummaryFix, GroupTotals, GroupingPanel, GroupingPanelItem, GroupingState, HeaderContextMenu, HyperLinksProvider, IntegratedFiltering, IntegratedGrouping, IntegratedSorting, IntegratedSummary, LinkProvider, NumberEditor, NumberFormatProvider, NumberFormatter, OtherOptions, OtherOptionsButton, Root, SearchState, SelectionState, SortingState, StubCell, SummaryCalculator, SummaryCell, SummaryState, SummaryType, TableColumnReordering, TableColumnResizing, TableColumnVisibility, TableContainer, TableFixedColumns, TableGroupRow, TableHeaderCell, TableHeaderRow, TableSummaryRow, TableWrapper, TextEditor, TextProvider, ToolbarIconButton, VirtualTable, booleanCompare, checkListCompare, checklistToNumber, commandComponentProps, createCompoundKey, createDefaultSummaryItems, customCalculator, dateCompare, dateTimeCompare, dateValidityCompare, defaultCustomCompare, exportCSV, exportPDF, filterColumns, filteredGroups, formatExportRows, generateGroupingExtensions, generateSortingExtensions, generateTableColumnExtension, generateTableColumnExtensions, getGroupKeys, getGroupingFunction, getGroupingStateExtensions, getRowId, highlightProjects, linkCompare, linkToString$1 as linkToString, listCompare, localizer, normalizeDate, nullUndefinedCompare, numberCompare, stringCompare, useDebouncedGridValue, useTable, useTableContext };
//# sourceMappingURL=hcss-tables.esm.js.map
